<template>
  <v-app class="fluxo-cobranca-page">
    <!-- Container 1: Filtros -->
    <v-container style="margin: 0px !important; padding: 0px !important">
      <v-container fluid style="margin: 0px">
        <v-card
          elevation="0"
          style="
            margin-top: 0px !important;
            margin-bottom: -30px !important;
            overflow: hidden;
            background-color: transparent;
          "
          class="px-5 py-1"
        >
          <v-row
            class="custom-gray-background fill-width filter-row"
            dense
            align="end"
            v-if="mostrarFiltro"
          >
            <v-col cols="12" sm="6" md="3" lg="3">
              <span>Empresa</span>
              <v-select
                v-model="selectedCompany"
                :items="companyOptions"
                label="Empresa"
                item-text="text"
                item-value="value"
                dense
                solo-inverted
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="3">
              <span>Filtrar por</span>
              <v-select
                v-model="selectMode"
                :items="['Data de Distribuição']"
                label="Filtrar"
                dense
                solo-inverted
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="2" lg="2">
              <span>Data Inicial</span>
              <v-menu
                v-model="isStartDatePickerOpen"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template #activator="{ on }">
                  <v-text-field
                    v-model="selectedStartDate"
                    label="Data inicial"
                    dense
                    solo-inverted
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  no-title
                  v-model="selectedStartDateISO"
                  @input="handleStartDateSelection"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" md="2" lg="2">
              <span>Data Final</span>
              <v-menu
                v-model="isEndDatePickerOpen"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template #activator="{ on }">
                  <v-text-field
                    v-model="selectedEndDate"
                    label="Data final"
                    dense
                    solo-inverted
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  no-title
                  v-model="selectedEndDateISO"
                  @input="handleEndDateSelection"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>

          <v-divider v-if="mostrarFiltro"></v-divider>

          <v-card-actions class="filter-actions">
            <v-btn
              @click="alternarVisibilidade"
              color="#4682B4"
              small
              class="mr-2"
              style="font-size: 14px !important; font-weight: bold"
            >
              {{ mostrarFiltro ? "Ocultar Filtro" : "Mostrar Filtro" }}
              <v-icon style="margin-left: 8px" dark>{{
                mostrarFiltro ? "mdi-eye-off" : "mdi-eye"
              }}</v-icon>
            </v-btn>

            <v-btn
              @click="limparFiltro"
              v-if="mostrarFiltro"
              color="#4682B4"
              small
              outlined
              class="mr-2"
              style="font-size: 14px !important; font-weight: bold"
            >
              Limpar
            </v-btn>
            <v-btn
              @click="applyRequiredFilters"
              v-if="mostrarFiltro"
              color="#4682B4"
              small
              :loading="isLoading"
              style="font-size: 14px !important; font-weight: bold"
            >
              Filtrar <v-icon style="margin-left: 8px" dark>mdi-filter</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-container>
    </v-container>

    <!-- Container 2: Indicadores -->
    <v-container fluid class="indicadores-container">
      <v-row dense>
        <v-col
          v-for="metric in boardMetrics"
          :key="metric.key"
          cols="12"
          sm="6"
          md="3"
        >
          <div class="metric-card-wrapper">
            <base-material-stats-card
              :color="metric.color"
              elevation="1"
              :icon="metric.icon"
              :title="metric.label"
              sub-icon-color="black"
              :value="isLoading ? '...' : metric.value"
              :valuex="false"
              :sub-text="metric.subtitle || ''"
            />

            <div v-if="metric.info" class="metric-info-icon">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                    size="20"
                  >
                    mdi-information-outline
                  </v-icon>
                </template>
                <span>{{ metric.info }}</span>
              </v-tooltip>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <!-- Container 3: Kanban -->
    <v-container fluid style="background-color: #eee">
      <div
        v-if="
          (hasAppliedRequiredFilters ||
          recoveryGoal > 0 ||
          monthlyRecoveredAmount > 0) &&
          canFilterResponsible
        "
        class="recovery-goal-panel"
      >
        <div class="recovery-goal-header">
          <div class="recovery-goal-title-row">
            <div class="recovery-goal-icon">
              <v-icon small color="#0f172a">mdi-bullseye</v-icon>
            </div>
            <div>
              <h3>Meta mensal de recuperação</h3>
              <p>Acompanhamento do valor recuperado vs. meta do mês</p>
            </div>
          </div>
          <div class="recovery-goal-summary">
            <span>
              {{ formatCurrency(monthlyRecoveredAmount) }} de
              {{ formatCurrency(recoveryGoal) }}
            </span>
            <strong>{{ recoveryProgressLabel }}</strong>
          </div>
        </div>

        <div class="recovery-progress-track">
          <div
            class="recovery-progress-fill"
            :style="{ width: `${recoveryProgressPercent}%` }"
          ></div>
        </div>

        <div class="recovery-goal-legend">
          <span>
            <i class="legend-dot recovered"></i>
            Recuperado:
            <strong>{{ formatCurrency(monthlyRecoveredAmount) }}</strong>
          </span>
          <span>
            <i class="legend-dot remaining"></i>
            A recuperar:
            <strong>{{ formatCurrency(recoveryRemainingAmount) }}</strong>
          </span>
          <span>
            <i class="legend-dot goal"></i>
            Meta:
            <strong>{{ formatCurrency(recoveryGoal) }}</strong>
          </span>
        </div>
      </div>

      <base-material-card
        icon="mdi-cash-sync"
        color="primary"
        title="Cobrança"
        style="margin-top: 20px !important; padding-top: 10px !important"
        class="px-5 py-0"
      >
        <v-row class="board-filters-row mt-1" dense align="center">
          <v-col cols="12" sm="6" md="3" lg="2">
            <v-text-field
              v-model="filters.search"
              label="Buscar por cliente ou contrato"
              prepend-inner-icon="mdi-magnify"
              class="board-filter-input"
              outlined
              dense
              hide-details
              clearable
            ></v-text-field>
          </v-col>
          <v-col v-if="canFilterResponsible" cols="12" sm="6" md="2" lg="2">
            <v-select
              v-model="filters.responsible"
              :items="responsibleOptions"
              label="Responsável"
              item-text="label"
              item-value="value"
              class="board-filter-input"
              outlined
              dense
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="2" lg="1">
            <v-select
              v-model="filters.priority"
              :items="priorityOptions"
              label="Prioridade"
              item-text="label"
              item-value="value"
              class="board-filter-input"
              outlined
              dense
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="2" lg="2">
            <v-select
              v-model="filters.lastContact"
              :items="lastContactOptions"
              label="Último contato"
              item-text="label"
              item-value="value"
              class="board-filter-input"
              outlined
              dense
              hide-details
            ></v-select>
          </v-col>
          <v-col
            v-if="overdueInstallmentOptions.length"
            cols="12"
            sm="6"
            md="2"
            lg="2"
          >
            <v-select
              v-model="filters.overdueInstallments"
              :items="overdueInstallmentOptions"
              label="Parcelas vencidas"
              item-text="label"
              item-value="value"
              class="board-filter-input"
              outlined
              dense
              hide-details
              multiple
              chips
              small-chips
              deletable-chips
            ></v-select>
          </v-col>
          <v-col
            v-if="contractTypeOptions.length"
            cols="12"
            sm="6"
            md="2"
            lg="2"
          >
            <v-select
              v-model="filters.contractType"
              :items="contractTypeOptions"
              label="Tipo contrato"
              item-text="label"
              item-value="value"
              class="board-filter-input"
              outlined
              dense
              hide-details
              multiple
              chips
              small-chips
              deletable-chips
            ></v-select>
          </v-col>
          <v-col
            v-if="canFilterResponsible && loteOptions.length > 1"
            cols="12"
            sm="6"
            md="2"
            lg="2"
          >
            <v-select
              v-model="filters.loteRef"
              :items="loteOptions"
              label="Lote"
              item-text="label"
              item-value="value"
              class="board-filter-input"
              outlined
              dense
              hide-details
            ></v-select>
          </v-col>
          <v-col v-if="tagOptions.length" cols="12" sm="6" md="2" lg="2">
            <v-select
              v-model="filters.tag"
              :items="tagOptions"
              label="Tag"
              item-text="label"
              item-value="value"
              class="board-filter-input"
              outlined
              dense
              hide-details
              multiple
              chips
              small-chips
              deletable-chips
            ></v-select>
          </v-col>
          <v-col cols="12" sm="auto" class="board-filter-actions">
            <v-btn
              small
              outlined
              color="primary"
              class="subtle-action-btn"
              @click="clearFilters"
            >
              <v-icon small>mdi-filter-remove-outline</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <div class="fluxo-view-toolbar">
          <v-btn-toggle
            v-model="boardViewMode"
            mandatory
            class="fluxo-view-toggle"
          >
            <v-btn value="kanban">
              <v-icon size="18" left>mdi-view-dashboard-outline</v-icon>
              Kanban
            </v-btn>

            <v-btn value="list">
              <v-icon size="18" left>mdi-format-list-bulleted</v-icon>
              Lista
            </v-btn>
          </v-btn-toggle>
        </div>

        <div v-if="boardViewMode === 'list'" class="ticket-list-view mt-6">
          <v-data-table
            :headers="ticketListHeaders"
            :items="filteredCards"
            :items-per-page="25"
            class="ticket-list-table no-hover-effect"
            dense
          >
            <template v-slot:item="row" >
              <tr :class="{ 'cor-row': row.index % 2 !== 0 }" @click="selectCard(row.item)" class="pointer">
                <td class="linha etapa-lista-cell">
                  <v-chip
                    x-small
                    dark
                    :color="
                      row.item.etapa_cor || getColumnColor(row.item.stage)
                    "
                  >
                    {{ row.item.stageName || "-" }}
                  </v-chip>
                </td>
                <td class="linha cliente-lista-cell">
                    {{ row.item.customerName || "-" }}
                  
                  <div class="lista-subtexto">
                    {{ row.item.document || row.item.cpf_cnpj || "-" }}
                  </div>
                </td>
                <td class="linha">{{ row.item.contractNumber || "-" }}</td>
                <td class="linha">{{ getCardLoteRef(row.item) || "-" }}</td>
                <td class="linha">{{ row.item.responsible || "-" }}</td>
                <td class="linha text-right">
                  {{ formatCurrency(row.item.valor_total_vencido) }}
                </td>
                <td class="linha text-right">
                  {{ formatCurrency(getCardPaidAmount(row.item)) }}
                </td>
                <td class="linha text-right">
                  {{ row.item.delayDays || 0 }}
                </td>
                <td class="linha">{{ getLastContactLabel(row.item) }}</td>
                <td class="linha tags-lista-cell">
                  <div class="list-tag-row">
                    <v-chip
                      v-for="tag in getCardTags(row.item)"
                      :key="tag.id || tag.nome"
                      x-small
                      :color="tag.cor || '#e2e8f0'"
                      :text-color="getTagTextColor(tag)"
                    >
                      {{ tag.nome }}
                    </v-chip>
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table>

          <div class="excel-export-row">
            <span
              class="excel-export-icon"
              :class="{
                disabled: !hasAppliedRequiredFilters || !filteredCards.length,
              }"
              title="Exportar Excel"
              @click="exportTicketsXls"
            >
              <v-progress-circular
                v-if="exportingTickets"
                indeterminate
                color="green"
                size="34"
                width="3"
              />
              <i v-else class="fas fa-file-excel"></i>
            </span>
          </div>
        </div>

        <div v-else class="kanban-board mt-12">
          <div class="kanban-columns">
            <section
              v-for="column in orderedColumns"
              :key="column.id"
              class="kanban-column"
            >
              <div
                class="column-header"
                :style="{ backgroundColor: column.color, opacity: 0.9 }"
              >
                <div class="d-flex align-center">
                  <div
                    class="column-icon"
                    :style="{ backgroundColor: column.color }"
                  >
                    <v-icon color="white" small>{{ column.icon }}</v-icon>
                  </div>
                  <div class="min-width-0">
                    <h3 class="column-title">{{ column.title }}</h3>
                  </div>
                </div>
                <div class="column-stats">
                  <v-chip
                    x-small
                    color="grey lighten-3"
                    text-color="grey darken-3"
                  >
                    {{ getCardsByColumn(column.id).length }}
                  </v-chip>
                  <strong>{{
                    formatCurrency(getColumnTotal(column.id))
                  }}</strong>
                </div>
              </div>

              <VueDraggable
                :value="getCardsByColumn(column.id)"
                group="fluxo-cobranca"
                item-key="id"
                class="card-list"
                :animation="200"
                :disabled="isLoading"
                @change="(event) => handleCardStageChange(event, column)"
              >
                <transition-group name="fade" type="transition">
                  <v-card
                    v-for="card in getVisibleCardsByColumn(column.id)"
                    :key="card.id"
                    class="finance-card"
                    elevation="1"
                    rounded="lg"
                    :style="`border-left: 6px solid ${column.color}`"
                    @click="selectCard(card)"
                  >
                    <v-card-text class="pa-3">
                      <div class="d-flex justify-space-between align-start">
                        <div>
                          <div class="card-code">{{ card.code }}</div>
                          <div class="card-customer-row">
                            <h4 class="card-customer">
                              {{ card.customerName }}
                            </h4>
                            <v-chip
                              v-if="isCardFalecido(card)"
                              x-small
                              color="red lighten-5"
                              text-color="red darken-3"
                              class="falecido-chip"
                            >
                              <v-icon x-small left>mdi-account-off</v-icon>
                              Falecido
                            </v-chip>
                          </div>
                        </div>

                        <v-btn
                          text
                          small
                          color="success"
                          v-bind="$attrs"
                          @click.stop="openWhatsAppAttendance(card)"
                          title="Novo atendimento WhatsApp"
                        >
                          <v-icon small>mdi-whatsapp</v-icon>
                        </v-btn>
                      </div>

                      <p class="card-description">{{ card.description }}</p>

                      <div v-if="getCardLoteRef(card)" class="card-batch">
                        <v-icon small>mdi-package-variant-closed</v-icon>
                        <span>{{ getCardLoteRef(card) }}</span>
                      </div>

                      <div class="card-amount-row">
                        <div>
                          <span>Valor Inadimplente</span>
                          <small>
                            {{ getOverdueInstallmentsLabel(card) }}
                          </small>
                        </div>
                        <strong>{{ formatCurrency(card.valor_total_vencido) }}</strong>
                      </div>

                      <div class="card-dates">
                        <span>
                          <v-icon small>mdi-calendar-clock-outline</v-icon>
                          <strong>Interação:</strong>
                          {{ formatDate(card.interactionDate || card.dueDate) }}
                        </span>
                        <span>
                          <v-icon small>mdi-file-document-outline</v-icon>
                          <strong>Contrato:</strong>
                          {{ formatDate(card.contractDate) }}
                        </span>
                      </div>

                      <div class="card-meta">
                        <span>
                          <v-icon small>mdi-account-outline</v-icon>
                          {{ card.responsible }}
                        </span>
                      </div>

                      <div class="card-meta contact-meta">
                        <span
                          v-if="getLastContactLabel(card) != 'Nunca contatado'"
                          class="contact-meta-label"
                          >Último contato:</span
                        >
                        <span class="contact-meta-value">
                          <v-icon small>mdi-phone-clock-outline</v-icon>
                          {{ getLastContactLabel(card) }}
                        </span>
                        <span
                          v-if="card.lastContactUser"
                          class="contact-meta-user text-truncate"
                        >
                          <v-icon small>mdi-account-clock-outline</v-icon>
                          {{ card.lastContactUser }}
                        </span>
                      </div>

                      <div class="card-tags">
                        <v-chip
                          v-for="tag in getCardTags(card)"
                          :key="`${card.id}-${tag.id}`"
                          x-small
                          :color="tag.cor"
                          :text-color="getTagTextColor(tag)"
                        >
                          {{ tag.nome }}
                        </v-chip>
                        <v-chip
                          x-small
                          :color="getPriorityConfig(card.priority).color"
                          :text-color="
                            getPriorityConfig(card.priority).textColor
                          "
                        >
                          {{ getPriorityConfig(card.priority).label }}
                        </v-chip>
                      </div>
                    </v-card-text>
                  </v-card>

                  <v-btn
                    v-if="hasMoreCards(column.id)"
                    :key="`${column.id}-load-more`"
                    text
                    small
                    block
                    color="primary"
                    class="load-more-btn mt-2"
                    @click="loadMoreCards(column.id)"
                  >
                    <v-icon small left>mdi-chevron-down</v-icon>
                    Ver mais ({{
                      getCardsByColumn(column.id).length -
                      (columnCardsLimit[column.id] || initialCardsPerColumn)
                    }}
                    restantes)
                  </v-btn>

                  <div
                    v-if="getCardsByColumn(column.id).length === 0"
                    :key="`${column.id}-empty`"
                    class="empty-column"
                  >
                    <span>Nenhum card nesta etapa</span>
                  </div>
                </transition-group>
              </VueDraggable>
            </section>
          </div>
        </div>
      </base-material-card>
    </v-container>

    <v-dialog v-model="detailDialog" max-width="920" scrollable persistent>
      <v-card v-if="selectedCard" class="customer-dialog">
        <v-btn
          text
          small
          class="dialog-close-btn"
          @click="detailDialog = false"
        >
          <v-icon small>mdi-close</v-icon>
        </v-btn>
        <v-card-title class="text-h3 dialog-title">
          <div class="dialog-header">
            <div class="min-width-0">
              <h2 class="dialog-customer">{{ selectedCard.customerName }}</h2>
              <div class="dialog-contract">
                <strong>{{
                  selectedCard.contractNumber || selectedCard.code
                }}</strong>

                <span class="mx-1">•</span>
                <span>{{ formatCpfMasked(selectedCard.document) }}</span>
                <span class="mx-1">•</span>
                <span>Interação #{{ selectedCard.id }}</span>
              </div>
              <div class="dialog-contract">
                <template v-if="getCardLoteRef(selectedCard)">
                  <span>Lote. {{ getCardLoteRef(selectedCard) }}</span>
                </template>

                <template v-if="selectedCard.reneg_id">
                  <span class="mx-1">•</span>
                  <span>Reneg. #{{ selectedCard.reneg_id }}</span>
                </template>
              </div>
            </div>
            <div class="dialog-amount">
              <span>Valor Inadimplente</span>
              <strong>{{
                formatCurrency(selectedCard.valor_total_vencido)
              }}</strong>
            </div>
          </div>
        </v-card-title>

        <v-card-text class="dialog-body pt-0">
          <div class="dialog-tags">
            <v-chip
              v-if="isCardFalecido(selectedCard)"
              small
              color="red lighten-5"
              text-color="red darken-3"
              class="font-weight-bold"
            >
              <v-icon small left>mdi-account-off</v-icon>
              Cliente falecido
            </v-chip>
            <v-chip small color="pink lighten-5" text-color="pink darken-2">
              {{ selectedCard.customerLabel || "Carteira" }}
            </v-chip>
            <v-chip small outlined color="blue-grey">
              {{ getDelayLabel(selectedCard) }}
            </v-chip>
            <v-chip small outlined color="blue-grey">
              {{ getOpenInstallmentsLabel(selectedCard) }}
            </v-chip>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-chip small outlined color="primary" v-bind="attrs" v-on="on">
                  <v-icon small left>mdi-plus</v-icon>
                  Adicionar Tag
                </v-chip>
              </template>
              <v-list dense>
                <v-list-item
                  v-for="tag in availableTags"
                  :key="tag.id"
                  @click="addTag(tag)"
                >
                  <v-list-item-content>
                    <v-list-item-title>{{
                      tag.nome || tag.name
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
          <div
            v-if="getCardTags(selectedCard).length"
            style="display: flex; flex-wrap: wrap; gap: 4px; margin-top: 4px"
          >
            <v-chip
              v-for="tag in getCardTags(selectedCard)"
              :key="`dialog-tag-${tag.id || tag}`"
              small
              close
              :color="tag.cor"
              :text-color="getTagTextColor(tag)"
              @click:close="removeTag(tag)"
            >
              {{ tag.nome || tag.name || tag }}
            </v-chip>
          </div>

          <div class="quick-actions">
            <span class="quick-actions-label">Ações rápidas:</span>
            <v-btn
              small
              outlined
              color="success"
              class="quick-action-btn"
              @click="openWhatsAppAttendance(selectedCard)"
            >
              <v-icon small left>mdi-whatsapp</v-icon>
              WhatsApp
            </v-btn>
            <v-btn
              v-if="canChangeRenegotiation(selectedCard)"
              small
              outlined
              color="warning"
              class="quick-action-btn"
              @click="
                openRenegotiationDialog(
                  selectedCard,
                  selectedCard.stage,
                  'edit',
                )
              "
            >
              <v-icon small left>mdi-file-document-edit-outline</v-icon>
              Alterar renegociação
            </v-btn>
            <v-btn
              v-if="canAssignResponsible"
              small
              outlined
              color="primary"
              class="quick-action-btn"
              @click="openResponsibleDialog(selectedCard)"
            >
              <v-icon small left>mdi-account-switch-outline</v-icon>
              Substituir responsável
            </v-btn>
          </div>

          <v-tabs
            v-model="detailTab"
            centered
            show-arrows
            class="custom-tabs"
            color="primary"
          >
            <v-tab v-for="tab in detailTabs" :key="tab.key">
              {{ tab.label }}
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="detailTab" class="detail-tabs-content mt-0">
            <v-tab-item>
              <div class="detail-section">
                <div class="section-kicker">
                  <v-icon small>mdi-heart-outline</v-icon>
                  Plano contratado
                </div>
                <h3 class="section-title">
                  {{
                    selectedCard.plan && selectedCard.plan.name
                      ? selectedCard.plan.name
                      : "Plano não informado"
                  }}
                </h3>
                <div
                  style="
                    font-size: 14px;
                    font-weight: 300;
                    color: #888;
                    margin-top: 2px;
                  "
                >
                  Data de adesão:
                  {{
                    selectedCard.data_contrato
                      ? selectedCard.data_contrato
                          .substring(0, 10)
                          .split("-")
                          .reverse()
                          .join("/")
                      : "-"
                  }}
                </div>

                <div class="data-grid">
                  <div
                    v-for="item in customerDataItems"
                    :key="item.key"
                    class="data-item"
                  >
                    <v-icon small>{{ item.icon }}</v-icon>
                    <span>{{ item.value }}</span>
                  </div>
                </div>

                <div class="section-kicker mt-4">
                  <v-icon small>mdi-shield-outline</v-icon>
                  Sinistros
                </div>
                <div v-if="getClaims(selectedCard).length">
                  <div
                    v-for="claim in getClaims(selectedCard)"
                    :key="claim.id"
                    class="record-row"
                  >
                    <div>
                      <strong>{{ claim.title }}</strong>
                      <span>{{ formatDate(claim.date) }}</span>
                    </div>
                    <v-chip small outlined color="blue-grey">{{
                      claim.status
                    }}</v-chip>
                  </div>
                </div>
                <div v-else class="empty-detail">
                  Nenhum sinistro registrado.
                </div>
              </div>
            </v-tab-item>

            <v-tab-item>
              <div class="detail-section">
                <div class="installment-filter">
                  <span>Histórico das mensalidades</span>
                  <div>
                    <v-chip
                      v-for="filter in installmentFilters"
                      :key="filter.key"
                      small
                      class="mr-1 mb-1"
                      :color="
                        installmentFilter === filter.key
                          ? 'primary'
                          : 'grey lighten-4'
                      "
                      :text-color="
                        installmentFilter === filter.key
                          ? 'white'
                          : 'blue-grey darken-2'
                      "
                      @click="installmentFilter = filter.key"
                    >
                      {{ filter.label }}
                    </v-chip>
                  </div>
                </div>

                <div v-if="filteredInstallments.length">
                  <div
                    v-for="installment in paginatedInstallments"
                    :key="installment.id"
                    class="installment-row"
                  >
                    <v-chip
                      small
                      :color="
                        getInstallmentStatusConfig(installment.status).color
                      "
                      dark
                      class="installment-status"
                    >
                      {{ getInstallmentStatusConfig(installment.status).label }}
                    </v-chip>

                    <div class="installment-main">
                      <strong>
                        {{ installment.reference || "Sem identificação" }}
                      </strong>
                      <span>
                        #{{ installment.id }}
                        <template v-if="installment.type">
                          · {{ installment.type }}
                        </template>
                      </span>
                    </div>

                    <div class="installment-values">
                      <span>Valor da parcela</span>
                      <strong>{{ formatCurrency(installment.amount) }}</strong>
                      <template v-if="installment.paidAmount != null">
                        <span>Valor recebido</span>
                        <strong class="received-value">
                          {{ formatCurrency(installment.paidAmount) }}
                        </strong>
                      </template>
                    </div>

                    <div class="installment-dates">
                      <span>
                        <v-icon x-small>mdi-calendar-outline</v-icon>
                        Vencimento: {{ formatDate(installment.dueDate) }}
                      </span>
                      <span v-if="installment.paidDate">
                        <v-icon x-small color="teal"
                          >mdi-check-circle-outline</v-icon
                        >
                        Pagamento: {{ formatDate(installment.paidDate) }}
                      </span>
                      <span v-else>
                        <v-icon x-small>mdi-minus-circle-outline</v-icon>
                        Pagamento não realizado
                      </span>
                    </div>
                  </div>
                  <v-pagination
                    v-if="totalInstallmentsPages > 1"
                    v-model="installmentsPage"
                    :length="totalInstallmentsPages"
                    :total-visible="5"
                    class="mt-4"
                  ></v-pagination>
                </div>
                <div v-else class="empty-detail">
                  Nenhuma parcela encontrada para este filtro.
                </div>
              </div>
            </v-tab-item>

            <v-tab-item>
              <div class="detail-section">
                <div v-if="paginatedAgreements.length">
                  <div
                    v-for="agreement in paginatedAgreements"
                    :key="agreement.id"
                    class="record-row"
                  >
                    <div>
                      <strong>{{ agreement.title }}</strong>
                      <span>
                        {{ formatDate(agreement.date) }}
                        -
                        {{ formatCurrency(agreement.amount) }}
                      </span>
                    </div>
                    <v-chip small outlined color="primary">{{
                      agreement.status
                    }}</v-chip>
                  </div>
                  <v-pagination
                    v-if="totalAgreementsPages > 1"
                    v-model="agreementsPage"
                    :length="totalAgreementsPages"
                    :total-visible="5"
                    class="mt-4"
                  ></v-pagination>
                </div>
                <div v-else class="empty-detail">Nenhum acordo registrado.</div>
              </div>
            </v-tab-item>

            <v-tab-item>
              <div class="detail-section">
                <div class="protocol-filter-row">
                  <span>Origem da interação</span>
                  <v-chip-group
                    v-model="protocolTypeFilter"
                    mandatory
                    active-class="primary white--text"
                    @change="interactionsPage = 1"
                  >
                    <v-chip
                      v-for="option in protocolTypeOptions"
                      :key="option.value"
                      :value="option.value"
                      small
                    >
                      {{ option.label }}
                    </v-chip>
                  </v-chip-group>
                </div>

                <div v-if="paginatedInteractions.length">
                  <div
                    v-for="interaction in paginatedInteractions"
                    :key="interaction.key"
                    class="interaction-row"
                  >
                    <div class="interaction-meta interaction-meta-header">
                      <div class="interaction-meta">
                        <v-icon small>{{
                          interaction.type === "WhatsApp"
                            ? "mdi-whatsapp"
                            : getInteractionIcon(interaction.channel)
                        }}</v-icon>
                        <v-chip small outlined color="blue-grey">
                          {{ interaction.type }}
                        </v-chip>
                        <span>{{ interaction.channel }}</span>
                        <span v-if="interaction.responsible">-</span>
                        <span v-if="interaction.responsible">{{
                          interaction.responsible
                        }}</span>
                        <span>-</span>
                        <span>{{ interaction.dateLabel }}</span>
                      </div>
                      <v-btn
                        v-if="interaction.type === 'WhatsApp'"
                        small
                        text
                        color="primary"
                        @click="openProtocolMessages(interaction.protocol)"
                      >
                        <v-icon small left>mdi-eye</v-icon>
                        Ver
                      </v-btn>
                    </div>
                    <div class="interaction-message">
                      <p
                        :class="{
                          'interaction-message-clamped':
                            interaction.type === 'iVertex' &&
                            !isInteractionExpanded(interaction.key),
                        }"
                      >
                        {{ interaction.message }}
                      </p>
                      <v-btn
                        v-if="interaction.type === 'iVertex'"
                        x-small
                        text
                        color="primary"
                        class="interaction-expand-btn"
                        @click="toggleInteractionExpansion(interaction.key)"
                      >
                        {{
                          isInteractionExpanded(interaction.key)
                            ? "Recolher"
                            : "Ver mais"
                        }}
                        <v-icon x-small right>
                          {{
                            isInteractionExpanded(interaction.key)
                              ? "mdi-chevron-up"
                              : "mdi-chevron-down"
                          }}
                        </v-icon>
                      </v-btn>
                    </div>
                    <div
                      v-if="interaction.type === 'WhatsApp'"
                      class="protocol-row-footer"
                    >
                      <div>
                        <v-chip
                          small
                          :color="getProtocolStatusColor(interaction.protocol)"
                          dark
                        >
                          {{ getProtocolStatusLabel(interaction.protocol) }}
                        </v-chip>
                      </div>
                      <span>{{ interaction.protocol.origem }}</span>
                    </div>
                  </div>
                  <v-pagination
                    v-if="totalInteractionsPages > 1"
                    v-model="interactionsPage"
                    :length="totalInteractionsPages"
                    :total-visible="5"
                    class="mt-4"
                  ></v-pagination>
                </div>
                <div v-else class="empty-detail">
                  Nenhuma interação registrada.
                </div>
              </div>
            </v-tab-item>

            <v-tab-item>
              <div class="detail-section">
                <div v-if="getStageHistory(selectedCard).length">
                  <div
                    v-for="stage in getStageHistory(selectedCard)"
                    :key="stage.id"
                    class="stage-history-row"
                  >
                    <div>
                      <strong>#{{ stage.id }} - {{ stage.etapaNome }}</strong>
                      <span>{{
                        stage.colaboradorNome || "Sem colaborador"
                      }}</span>
                    </div>
                    <div class="stage-history-dates">
                      <span>Entrada: {{ formatDateTime(stage.dtInicio) }}</span>
                      <span>Saída: {{ formatDateTime(stage.dtFim) }}</span>
                    </div>
                  </div>
                </div>
                <div v-else class="empty-detail">
                  Nenhum histórico de etapa registrado.
                </div>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="stage-actions px-6 py-4">
          <div class="stage-actions">
            <span>Mover este card para:</span>
            <div class="stage-buttons">
              <v-btn
                v-for="column in orderedColumns"
                :key="`move-${column.id}`"
                small
                outlined
                class="subtle-action-btn"
                :disabled="selectedCard.stage === column.id"
                @click="moveSelectedCardToStage(column.id)"
              >
                {{ column.title }}
              </v-btn>
            </div>
            <v-btn
              small
              color="blue-grey darken-4"
              dark
              depressed
              class="primary-stage-btn mt-4"
              @click="advanceSelectedCard"
            >
              Avancar: {{ getNextStageTitle(selectedCard) }}
              <v-icon small right>mdi-arrow-right</v-icon>
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="responsibleDialog" max-width="560" persistent>
      <v-card>
        <v-card-title class="headline primary white--text">
          Substituir responsável
        </v-card-title>
        <v-card-text class="pa-5">
          <div v-if="pendingResponsibleCard" class="responsible-context">
            <strong>{{ pendingResponsibleCard.customerName }}</strong>
            <span>
              <small>Atual</small>
              {{ pendingResponsibleCard.responsible || "-" }}
            </span>
          </div>

          <v-autocomplete
            v-model="selectedResponsibleCpf"
            :items="activeCollaboratorOptions"
            :loading="loadingCollaborators"
            :disabled="loadingCollaborators || savingResponsible"
            label="Novo responsável"
            prepend-inner-icon="mdi-account-search-outline"
            item-text="label"
            item-value="value"
            outlined
            dense
            hide-details="auto"
            clearable
            auto-select-first
            no-data-text="Nenhum colaborador ativo encontrado para a empresa"
          >
            <template v-slot:item="{ item }">
              <div class="responsible-option">
                <strong>{{ item.name }}</strong>
                <span>{{ item.meta }}</span>
              </div>
            </template>

            <template v-slot:selection="{ item }">
              <span class="responsible-selection">{{ item.name }}</span>
            </template>
          </v-autocomplete>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text :disabled="savingResponsible" @click="closeResponsibleDialog">
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            :loading="savingResponsible"
            :disabled="!selectedResponsibleCpf"
            @click="confirmResponsibleChange"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="unlinkRenegDialog" max-width="520" persistent>
      <v-card>
        <v-card-title class="headline primary white--text">
          Desvincular renegociação
        </v-card-title>
        <v-card-text class="pa-5">
          <p class="mb-2">
            Este ticket está em <strong>Promessa de pagamento</strong> e possui
            uma renegociação vinculada.
          </p>
          <p class="mb-0">
            Ao voltar para uma etapa anterior, a renegociação
            <strong v-if="pendingUnlinkRenegCard">
              #{{ pendingUnlinkRenegCard.renegId }}
            </strong>
            será desvinculada do ticket.
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text :disabled="unlinkRenegLoading" @click="cancelRenegotiationUnlink">
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            :loading="unlinkRenegLoading"
            @click="confirmRenegotiationUnlink"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="renegDialog" max-width="760" persistent scrollable>
      <v-card>
        <v-card-title class="headline primary white--text">
          {{
            renegDialogMode === "edit"
              ? "Alterar renegociação"
              : "Selecionar renegociação"
          }}
        </v-card-title>

        <v-card-text class="pa-4">
          <div v-if="pendingRenegCard" class="reneg-context">
            <strong>{{ pendingRenegCard.customerName }}</strong>
            <span
              >Contrato:
              {{
                pendingRenegCard.contractNumber || pendingRenegCard.code
              }}</span
            >
          </div>

          <div v-if="loadingRenegotiations" class="protocol-loading">
            <v-progress-circular indeterminate color="primary" size="28" />
            <span>Buscando renegociações...</span>
          </div>

          <v-alert
            v-else-if="!renegotiations.length"
            type="warning"
            outlined
            dense
            class="mb-0"
          >
            Nenhuma renegociação encontrada para este contrato.
          </v-alert>

          <v-radio-group
            v-else
            v-model="selectedRenegotiationId"
            mandatory
            class="reneg-list"
          >
            <div
              v-for="reneg in renegotiations"
              :key="reneg.id"
              class="reneg-option"
              @click="selectedRenegotiationId = reneg.id"
            >
              <v-radio :value="reneg.id" color="primary"></v-radio>
              <div class="reneg-option-body">
                <div class="reneg-option-title">
                  <strong>Renegociação #{{ reneg.id }}</strong>
                  <span>{{
                    formatDate(reneg.dataCriacao || reneg.data_criacao)
                  }}</span>
                </div>
                <div class="reneg-option-grid">
                  <span
                    >Valor:
                    {{
                      formatCurrency(
                        reneg.valorRenegociado || reneg.valor_renegociado,
                      )
                    }}</span
                  >
                  <span>Parcelas: {{ reneg.parcelamento || "-" }}</span>
                  <span>Desconto: {{ formatCurrency(reneg.desconto) }}</span>
                  <span>Operador: {{ reneg.operador || "-" }}</span>
                </div>
              </div>
            </div>
          </v-radio-group>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cancelRenegotiationDialog">Cancelar</v-btn>
          <v-btn
            color="primary"
            :loading="savingRenegotiation"
            :disabled="!selectedRenegotiationId || !renegotiations.length"
            @click="confirmRenegotiationSelection"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="protocolMessagesDialog" max-width="820" scrollable>
      <v-card>
        <v-card-title class="headline primary white--text">
          Mensagens do protocolo
          <span v-if="selectedProtocol" class="ml-2">
            {{ selectedProtocol.protocolNumber }}
          </span>
        </v-card-title>

        <v-card-text class="protocol-messages-card">
          <div v-if="protocolMessagesLoading" class="protocol-loading">
            <v-progress-circular indeterminate color="primary" size="28" />
            <span>Carregando mensagens...</span>
          </div>

          <div
            v-else-if="!selectedProtocolMessages.length"
            class="empty-detail"
          >
            Nenhuma mensagem encontrada para este protocolo.
          </div>

          <div v-else class="protocol-message-list">
            <div
              v-for="message in selectedProtocolMessages"
              :key="message._id || message.id || message.messageId"
              :class="[
                'protocol-message-bubble',
                isOutgoingProtocolMessage(message)
                  ? 'outgoing-message'
                  : 'incoming-message',
              ]"
            >
              <div class="protocol-message-meta">
                <strong>{{
                  isOutgoingProtocolMessage(message) ? "Atendente" : "Cliente"
                }}</strong>
                <span>{{
                  formatDateTime(message.createdAt || message.dataCreate)
                }}</span>
              </div>

              <div v-if="message.fileUrl" class="protocol-message-file">
                <v-btn
                  small
                  outlined
                  color="primary"
                  :href="message.fileUrl"
                  target="_blank"
                >
                  <v-icon small left>mdi-paperclip</v-icon>
                  Abrir arquivo
                </v-btn>
              </div>
              <p v-else>{{ getProtocolMessageText(message) }}</p>

              <div v-if="message.userInsert" class="protocol-message-user">
                Enviado por: {{ message.userInsert }}
              </div>
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeProtocolMessagesDialog">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="whatsAppDialog" max-width="720" persistent scrollable>
      <v-card>
        <v-card-title class="headline primary white--text">
          Novo Atendimento WhatsApp
        </v-card-title>

        <v-card-text class="pa-4">
          <v-alert
            v-if="whatsAppError"
            type="error"
            dense
            outlined
            class="mb-4"
          >
            {{ whatsAppError }}
          </v-alert>

          <v-form
            ref="whatsAppForm"
            v-model="whatsAppFormValid"
            lazy-validation
          >
            <v-select
              v-model="whatsAppTemplateId"
              :items="activeWhatsAppTemplates"
              item-text="name"
              item-value="_id"
              label="Selecione um template"
              :loading="loadingWhatsAppTemplates"
              :disabled="loadingWhatsAppTemplates"
              @change="onWhatsAppTemplateChange"
              clearable
              outlined
              hide-details
              dense
              class="mb-3"
            ></v-select>

            <v-card v-if="whatsAppTemplate" flat outlined class="mb-4">
              <v-card-subtitle class="caption">
                Template: {{ whatsAppTemplate.name }}
              </v-card-subtitle>
              <v-card-text class="pa-2">
                <div class="caption">{{ whatsAppTemplate.content }}</div>
              </v-card-text>
            </v-card>

            <div class="d-flex align-center mb-3">
              <v-select
                v-model="whatsAppSearchType"
                :items="whatsAppSearchTypes"
                item-text="text"
                item-value="value"
                label="Tipo"
                outlined
                dense
                hide-details
                class="mr-2"
                style="max-width: 150px"
              ></v-select>
              <v-text-field
                v-model="whatsAppSearchValue"
                :label="whatsAppSearchLabel"
                outlined
                dense
                hide-details
                class="flex-grow-1"
              >
                <template v-slot:append>
                  <v-btn
                    text
                    color="primary"
                    :loading="loadingWhatsAppClients"
                    :disabled="!canSearchWhatsAppClient"
                    @click="searchWhatsAppClient"
                    title="Buscar cliente"
                  >
                    <v-icon small>mdi-magnify</v-icon>
                  </v-btn>
                </template>
              </v-text-field>
            </div>

            <v-alert
              v-if="whatsAppClientError"
              type="warning"
              dense
              outlined
              class="mb-3"
            >
              {{ whatsAppClientError }}
            </v-alert>

            <div
              v-if="whatsAppSelectedClient"
              class="mb-4 pa-3 grey lighten-4 rounded"
            >
              <div class="d-flex justify-space-between align-center mb-2">
                <div class="subtitle-1 font-weight-bold">
                  Cliente selecionado
                </div>
                <v-btn
                  x-small
                  text
                  color="primary"
                  @click="clearWhatsAppSelectedClient"
                >
                  <v-icon x-small left>mdi-account-switch</v-icon>
                  Trocar
                </v-btn>
              </div>
              <div class="d-flex align-center">
                <v-avatar size="36" color="primary" class="white--text mr-3">
                  {{
                    whatsAppSelectedClient.nome
                      ? whatsAppSelectedClient.nome.charAt(0).toUpperCase()
                      : "?"
                  }}
                </v-avatar>
                <div>
                  <div class="subtitle-2 font-weight-medium">
                    {{ whatsAppSelectedClient.nome || "Nome não informado" }}
                  </div>
                  <div class="caption">
                    <span class="font-weight-medium">CPF:</span>
                    {{
                      formatCpf(whatsAppSelectedClient.cpf) || "Não informado"
                    }}
                  </div>
                </div>
              </div>

              <div
                v-if="
                  whatsAppSelectedClient.contratos &&
                  whatsAppSelectedClient.contratos.length > 0
                "
                class="mt-4"
              >
                <div class="subtitle-1 font-weight-medium mb-2">
                  Contratos ({{ whatsAppSelectedClient.contratos.length }})
                </div>
                <v-expansion-panels>
                  <v-expansion-panel
                    v-for="contrato in whatsAppSelectedClient.contratos"
                    :key="contrato.id"
                    class="expansion-panel"
                  >
                    <v-expansion-panel-header>
                      <div>
                        <div class="font-weight-medium">
                          {{ contrato.tipo }}
                        </div>
                        <div class="caption">
                          <v-chip
                            x-small
                            :color="
                              contrato.status === 'Ativo' ||
                              contrato.status === 'ATIVO'
                                ? 'success'
                                : 'red'
                            "
                            class="mr-1"
                          >
                            {{ contrato.status }}
                          </v-chip>
                          Ref: {{ contrato.referencia }}
                        </div>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content expand>
                      <v-divider></v-divider>

                      <div class="py-3">
                        <div>
                          <strong>Empresa:</strong> {{ contrato.empresa }}
                        </div>
                        <div>
                          <strong>Data:</strong>
                          {{ formatDate(contrato.dataContrato) }}
                        </div>

                        <div v-if="contrato.ltv" class="mt-4">
                          <v-divider class="my-1"></v-divider>
                          <div class="subtitle-2 mb-1">Informações de LTV</div>

                          <v-row dense class="py-2">
                            <v-col cols="12" sm="6" class="py-0">
                              <div class="caption">
                                <strong>Severidade:</strong>
                                {{ contrato.ltv.severidade }}
                              </div>
                            </v-col>
                            <v-col cols="12" sm="6" class="py-0">
                              <div class="caption">
                                <strong>LTV:</strong>
                                {{ contrato.ltv.ltv?.toFixed(4) }}
                              </div>
                            </v-col>
                            <v-col cols="12" sm="6" class="py-0">
                              <div class="caption">
                                <strong>Debito Cliente:</strong> R$
                                {{ contrato.ltv.debitoCliente?.toFixed(2) }}
                              </div>
                            </v-col>
                            <v-col cols="12" sm="6" class="py-0">
                              <div class="caption">
                                <strong>% Aplicado:</strong>
                                {{ contrato.ltv.percentualAplicado }}
                              </div>
                            </v-col>
                            <v-col cols="12" sm="6" class="py-0">
                              <div class="caption">
                                <strong>Desconto:</strong> R$
                                {{ contrato.ltv.desconto?.toFixed(2) }}
                              </div>
                            </v-col>
                            <v-col cols="12" sm="6" class="py-0">
                              <div class="caption">
                                <strong>Valor Final:</strong> R$
                                {{ contrato.ltv.valorFinal?.toFixed(2) }}
                              </div>
                            </v-col>
                            <v-col cols="12" class="py-0">
                              <div class="caption">
                                <strong>Oferta:</strong>
                                {{ contrato.ltv.oferta }}
                              </div>
                            </v-col>
                          </v-row>
                        </div>
                      </div>

                      <v-divider></v-divider>

                      <v-tabs
                        v-model="whatsAppActiveTab"
                        background-color="transparent"
                        color="primary"
                        grow
                        class="mt-3"
                      >
                        <v-tab>
                          <v-icon left small>mdi-cash-multiple</v-icon>
                          Parcelas
                        </v-tab>
                        <v-tab>
                          <v-icon left small>mdi-history</v-icon>
                          Interações
                        </v-tab>
                      </v-tabs>
                      <v-tabs-items v-model="whatsAppActiveTab">
                        <v-tab-item>
                          <div class="pa-0 pt-4">
                            <div
                              v-if="!contrato.parcelas?.length"
                              class="caption text-center pa-4"
                            >
                              <v-icon large color="blue-grey lighten-2">
                                mdi-cash-remove
                              </v-icon>
                              <div class="mt-2">
                                Nenhuma parcela em aberta encontrada
                              </div>
                            </div>

                            <v-data-table
                              v-else
                              :headers="[]"
                              :items="contrato.parcelas"
                              hide-default-header
                              :items-per-page="5"
                              class="elevation-0 mt-2"
                              :footer-props="{
                                'items-per-page-options': [5, 10, 15],
                                'show-current-page': true,
                                'show-first-last-page': true,
                                'items-per-page-text': 'Itens por pagina:',
                              }"
                            >
                              <template v-slot:item="{ item: parcela }">
                                <tr>
                                  <td>
                                    <div class="py-2 border-bottom">
                                      <div
                                        class="caption d-flex justify-space-between"
                                      >
                                        <div class="subtitle-2">
                                          {{ formatDateBR(parcela.vencimento) }}
                                        </div>
                                        <v-chip
                                          small
                                          :color="
                                            getVencimentoColor(
                                              parcela.vencimento,
                                              parcela.status,
                                            )
                                          "
                                          :text-color="
                                            getVencimentoColor(
                                              parcela.vencimento,
                                              parcela.status,
                                            ) === 'error'
                                              ? 'white'
                                              : ''
                                          "
                                        >
                                          {{
                                            getVencimentoStatus(
                                              parcela.vencimento,
                                              parcela.status,
                                            )
                                          }}
                                        </v-chip>
                                      </div>
                                      <div
                                        class="caption d-flex justify-space-between align-center mt-2"
                                      >
                                        <div class="d-flex align-center">
                                          <div class="caption">
                                            Identificação:
                                            {{ parcela.identificacao }}
                                          </div>
                                        </div>

                                        <div class="subtitle-2">
                                          R$
                                          {{
                                            parcela.valor
                                              ? parcela.valor
                                                  .toFixed(2)
                                                  .replace(".", ",")
                                              : "0,00"
                                          }}
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </template>
                            </v-data-table>
                          </div>
                        </v-tab-item>

                        <v-tab-item>
                          <div class="pa-0 pt-4">
                            <div
                              v-if="!contrato.interacoes?.length"
                              class="caption text-center pa-4"
                            >
                              <v-icon large color="blue-grey lighten-2">
                                mdi-message-text-outline
                              </v-icon>
                              <div class="mt-2">
                                Nenhuma interação encontrada
                              </div>
                            </div>

                            <v-data-table
                              v-else
                              :headers="[]"
                              :items="contrato.interacoes"
                              hide-default-header
                              :items-per-page="5"
                              class="elevation-0 mt-2"
                              :footer-props="{
                                'items-per-page-options': [5, 10, 15],
                                'show-current-page': true,
                                'show-first-last-page': true,
                                'items-per-page-text': 'Itens por pagina:',
                              }"
                            >
                              <template v-slot:item="{ item: i }">
                                <tr>
                                  <td>
                                    <div class="py-2 border-bottom">
                                      <div class="caption">
                                        {{ i.assunto }}
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </template>
                            </v-data-table>
                          </div>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
            </div>

            <v-text-field
              v-model="whatsAppPhoneNumber"
              label="Número de telefone"
              prefix="+55"
              required
              outlined
              dense
              hide-details
              readonly
              class="mb-3"
            ></v-text-field>

            <template v-if="whatsAppTemplate">
              <v-text-field
                v-for="(param, index) in extractTemplateParams(
                  whatsAppTemplate.content,
                )"
                :key="index"
                v-model="whatsAppTemplateParams[index]"
                :label="
                  whatsAppTemplateParamLabels[index] || `Parametro ${index + 1}`
                "
                required
                outlined
                hide-details
                dense
                class="mb-2"
              ></v-text-field>
            </template>
          </v-form>
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn text @click="closeWhatsAppDialog">Cancelar</v-btn>
          <v-btn
            color="primary"
            :loading="sendingWhatsAppMessage || checkingWhatsAppContact"
            :disabled="!canSendWhatsAppTemplate"
            @click="checkWhatsAppContactAndSend"
          >
            <v-icon left>mdi-send</v-icon>
            Enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="whatsAppClientInfoDialog" max-width="800" scrollable>
      <v-card class="pt-0">
        <v-card-title class="headline primary white--text">
          Detalhes do Cliente
        </v-card-title>

        <v-card-text>
          <div v-if="loadingWhatsAppClients" class="text-center py-5">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
            <div class="mt-3">Carregando informações do cliente...</div>
          </div>

          <div
            v-else-if="whatsAppClientInfoError"
            class="text-center py-5 pt-12"
          >
            <v-alert type="error" outlined>
              {{ whatsAppClientInfoError }}
            </v-alert>
            <v-btn color="primary" @click="searchWhatsAppClient" class="mt-3">
              <v-icon left>mdi-refresh</v-icon>
              Tentar novamente
            </v-btn>
          </div>

          <div v-else-if="!whatsAppClientInfo" class="text-center py-5">
            <v-alert type="info" outlined>
              Nenhuma informação disponível para este cliente.
            </v-alert>
          </div>

          <div v-else class="mt-4">
            <div class="mb-4">
              <div class="d-flex align-center mb-2">
                <v-chip color="primary" small class="mr-2">
                  {{ whatsAppClientsCount }} clientes encontrados
                </v-chip>
                <div class="caption">Selecione um cliente para continuar</div>
              </div>

              <v-data-table
                :headers="whatsAppClientHeaders"
                :items="whatsAppClients"
                :items-per-page="10"
                class="elevation-0"
                @click:row="selectWhatsAppClientAndClose"
                :loading="loadingWhatsAppClients"
              >
                <template v-slot:item.nome="{ item }">
                  <div class="font-weight-medium">
                    {{ item.nome || "Nome não informado" }}
                  </div>
                </template>

                <template v-slot:item.cpf="{ item }">
                  {{ formatCpf(item.cpf) || "Não informado" }}
                </template>

                <template v-slot:item.telefone="{ item }">
                  {{ item.telefone || "Não informado" }}
                </template>

                <template v-slot:item.actions="{ item, index }">
                  <v-btn
                    x-small
                    color="primary"
                    @click.stop="selectWhatsAppClientAndClose(item, index)"
                  >
                    <v-icon x-small left>mdi-check</v-icon>
                    Selecionar
                  </v-btn>
                </template>
              </v-data-table>
            </div>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="whatsAppClientInfoDialog = false"
            small
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn icon small v-bind="attrs" @click="snackbar.show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import VueDraggable from "vuedraggable";
import fluxoCobrancaService from "@/services/fluxoCobranca.service";
import SonaxService from "@/services/v2sonax";

const COBRANCA_STAGE_IDS = Object.freeze({
  NOVO: 26,
  TENTATIVA_CONTATO: 27,
  CONTATO_REALIZADO: 28,
  EM_NEGOCIACAO: 29,
  PROMESSA_PAGAMENTO: 30,
  ACORDO_CANCELADO: 31,
  PAGO_QUITADO: 32,
  FALHA: 33,
});

export default {
  name: "FluxoCobranca",
  components: {
    VueDraggable,
  },
  data() {
    return {
      isLoading: false,
      loadingRecoveryGoal: false,
      loadingRecoveredAmount: false,
      loadingCardDetails: false,
      exportingTickets: false,
      detailDialog: false,
      selectedCard: null,
      detailTab: 0,
      installmentFilter: "todas",
      installmentsPage: 1,
      installmentsPerPage: 5,
      agreementsPage: 1,
      agreementsPerPage: 10,
      interactionsPage: 1,
      interactionsPerPage: 5,
      protocolTypeFilter: "todos",
      expandedInteractionKeys: [],
      protocolTypeOptions: [
        { value: "todos", label: "Todos" },
        { value: "iVertex", label: "iVertex" },
        { value: "WhatsApp", label: "WhatsApp" },
        { value: "Ligacao", label: "Ligação" },
      ],
      protocolMessagesDialog: false,
      protocolMessagesLoading: false,
      selectedProtocol: null,
      selectedProtocolMessages: [],
      renegDialog: false,
      loadingRenegotiations: false,
      savingRenegotiation: false,
      renegotiations: [],
      selectedRenegotiationId: null,
      pendingRenegCard: null,
      pendingRenegStage: null,
      renegDialogMode: "move",
      unlinkRenegDialog: false,
      unlinkRenegLoading: false,
      pendingUnlinkRenegCard: null,
      pendingUnlinkRenegStage: null,
      pendingUnlinkRenegReloadOnCancel: false,
      responsibleDialog: false,
      loadingCollaborators: false,
      savingResponsible: false,
      activeCollaborators: [],
      selectedResponsibleCpf: null,
      pendingResponsibleCard: null,
      availableTags: [],
      columnCardsLimit: {},
      initialCardsPerColumn: 5,
      cardsIncrement: 5,
      hasAppliedRequiredFilters: false,
      filterAlert: "",
      selectedCompany: "",
      selectedStartDate: "",
      selectedEndDate: "",
      selectedStartDateISO: "",
      selectedEndDateISO: "",
      selectMode: "Data de Distribuição",
      boardViewMode: "kanban",
      mostrarFiltro: true,
      isStartDatePickerOpen: false,
      isEndDatePickerOpen: false,
      board: {
        title: "",
        subtitle: "",
        updatedAt: null,
      },
      columns: [],
      cards: [],
      recoveryGoal: 0,
      recoveredAmountValue: 0,
      companyOptions: [],
      filters: {
        search: "",
        responsible: "todos",
        priority: "todos",
        lastContact: "todos",
        overdueInstallments: [],
        contractType: [],
        loteRef: "todos",
        tag: [],
      },
      lastContactOptions: [
        { value: "todos", label: "Todos" },
        { value: "never", label: "Nunca contatados" },
        { value: "7", label: "Sem contato nos últimos 7 dias" },
        { value: "15", label: "Sem contato nos últimos 15 dias" },
        { value: "30", label: "Sem contato nos últimos 30 dias" },
        { value: "60", label: "Sem contato nos últimos 60 dias" },
        { value: "90", label: "Sem contato nos últimos 90 dias" },
      ],
      ticketListHeaders: [
        { text: "Etapa", value: "stageName", width: "150" },
        { text: "Cliente", value: "customerName", width: "220" },
        { text: "Contrato", value: "contractNumber", width: "120" },
        { text: "Lote", value: "loteRef", width: "120" },
        { text: "Responsável", value: "responsible", width: "170" },
        { text: "Vencido", value: "valor_total_vencido", align: "end" },
        { text: "Recebido", value: "paidAmount", align: "end" },
        { text: "Atraso", value: "delayDays", align: "end" },
        { text: "Último contato", value: "lastContactAt", width: "180" },
        { text: "Tags", value: "tags", sortable: false, width: "220" },
      ],
      detailTabs: [
        { key: "dados", label: "Dados" },
        { key: "parcelas", label: "Parcelas" },
        { key: "acordos", label: "Acordos" },
        { key: "interacoes", label: "Interações" },
        { key: "historico", label: "Histórico" },
      ],
      installmentFilters: [
        { key: "todas", label: "Todas" },
        { key: "paga", label: "Pagas" },
        { key: "a_vencer", label: "A vencer" },
        { key: "vencida", label: "Vencidas" },
      ],
      priorityMap: {
        baixa: {
          label: "Baixa",
          color: "grey lighten-3",
          textColor: "grey darken-3",
        },
        media: {
          label: "Média",
          color: "blue lighten-5",
          textColor: "blue darken-3",
        },
        alta: {
          label: "Alta",
          color: "orange lighten-5",
          textColor: "orange darken-4",
        },
        critica: {
          label: "Crítica",
          color: "red lighten-5",
          textColor: "red darken-3",
        },
      },
      installmentStatusMap: {
        paga: { label: "pago", color: "teal" },
        a_vencer: { label: "a vencer", color: "blue" },
        vencida: { label: "vencida", color: "red" },
      },
      snackbar: {
        show: false,
        text: "",
        color: "info",
        timeout: 3000,
      },
      whatsAppDialog: false,
      whatsAppClientInfoDialog: false,
      whatsAppSourceCard: null,
      whatsAppFormValid: true,
      whatsAppError: "",
      whatsAppTemplates: [],
      whatsAppTemplate: null,
      whatsAppTemplateId: null,
      whatsAppTemplateParams: [],
      whatsAppTemplateParamLabels: [],
      loadingWhatsAppTemplates: false,
      loadingWhatsAppClients: false,
      sendingWhatsAppMessage: false,
      checkingWhatsAppContact: false,
      whatsAppPhoneNumber: "",
      whatsAppSearchType: "telefone",
      whatsAppSearchValue: "",
      whatsAppClients: [],
      whatsAppClientInfo: null,
      whatsAppClientInfoError: null,
      whatsAppSelectedClientIndex: 0,
      whatsAppSelectedClient: null,
      whatsAppActiveTab: 0,
      whatsAppClientError: "",
      whatsAppSentProtocol: null,
      whatsAppClientHeaders: [
        { text: "ID", value: "idCliente", sortable: true },
        { text: "Nome", value: "nome", sortable: true },
        { text: "CPF", value: "cpf", sortable: true },
        { text: "Telefone", value: "telefone", sortable: true },
        { text: "Ações", value: "actions", sortable: false, align: "center" },
      ],
      whatsAppSearchTypes: [
        { text: "Telefone", value: "telefone" },
        { text: "Nome", value: "nome" },
        { text: "CPF", value: "cpf" },
      ],
      empresasTelefones: [
        {
          nome: "PREVIDA",
          aliases: ["PREVIDA"],
          telefones: [{ label: "Ativo", numero: "558282308177" }],
        },
        {
          nome: "MEMORIAL PARQUE MACEIO",
          aliases: ["MEMORIAL PARQUE MACEIO", "MEMORIAL PARQUE MACEIÓ"],
          telefones: [{ label: "Ativo", numero: "558299289412" }],
        },
        {
          nome: "PARQUE DAS FLORES",
          aliases: ["PARQUE DAS FLORES"],
          telefones: [{ label: "Ativo", numero: "558296411028" }],
        },
        {
          nome: "CEMITERIO PREVIDA",
          aliases: ["CEMITERIO PREVIDA"],
          telefones: [{ label: "Principal", numero: "558000829000" }],
        },
        {
          nome: "CEMITERIO PREVIDA SAO MIGUEL",
          aliases: [
            "CEMITERIO PREVIDA SAO MIGUEL",
            "CEMITERIO PREVIDA SÃO MIGUEL",
          ],
          telefones: [{ label: "Principal", numero: "558000829000" }],
        },
        {
          nome: "PARQUE DO AGRESTE",
          aliases: ["PARQUE DO AGRESTE"],
          telefones: [{ label: "Principal", numero: "558000829000" }],
        },
        {
        nome: "A FLOR DO CAFE",
        aliases: ["A FLOR DO CAFE"],
        telefones: [
          {
            label: "Principal",
            numero: "558000829000",
            numeroFormatado: "0800 082 9000",
          },
        ],
      },
      ],
    };
  },
  computed: {
    orderedColumns() {
      return [...this.columns].sort((a, b) => a.order - b.order);
    },
    canFilterResponsible() {
      const roles = this.getUserRoles();
      return (
        roles.includes("ROLE_ADMIN") ||
        roles.includes("ROLE_COBRANCA") ||
        roles.includes("ROLE_FLUXO_COBRANCA_CONSULTA_SUPERVISOR")
      );
    },
    canAssignResponsible() {
      const roles = this.getUserRoles();
      return (
        roles.includes("ROLE_ADMIN") ||
        roles.includes("ROLE_FLUXO_COBRANCA")
      );
    },
    filteredCards() {
      const search = (this.filters.search || "").toLowerCase();
      return this.cards.filter((card) => {
        const matchesSearch =
          !search ||
          this.getCardText(card.customerName).includes(search) ||
          this.getCardText(card.code).includes(search);
        const matchesResponsible =
          this.filters.responsible === "todos" ||
          card.responsible === this.filters.responsible;
        const matchesPriority =
          this.filters.priority === "todos" ||
          card.priority === this.filters.priority;
        const matchesLastContact = this.matchesLastContactFilter(card);
        const matchesOverdueInstallments =
          !this.filters.overdueInstallments.length ||
          this.filters.overdueInstallments.includes(
            this.getOverdueInstallments(card),
          );
        const matchesContractType =
          !this.filters.contractType.length ||
          this.filters.contractType.includes(this.getCardContractType(card));
        const matchesLote =
          !this.canFilterResponsible ||
          !this.filters.loteRef ||
          this.filters.loteRef === "todos" ||
          this.getCardLoteRef(card) === this.filters.loteRef;
        const matchesTag =
          !this.filters.tag.length ||
          this.filters.tag.some((filterId) =>
            this.getCardTags(card).some((tag) => tag.id === filterId),
          );

        return (
          matchesSearch &&
          matchesResponsible &&
          matchesPriority &&
          matchesLastContact &&
          matchesOverdueInstallments &&
          matchesContractType &&
          matchesLote &&
          matchesTag
        );
      });
    },
    boardMetrics() {
      return [
        {
          key: "cards",
          label: "Total Clientes",
          value: this.filteredCards.length,
          icon: "mdi-account-multiple",
          color: "info",
          subtitle: "",
        },
        {
          key: "total",
          label: "Total Inadimplência",
          value: this.formatCurrency(this.totalAmount),
          icon: "mdi-alert-circle",
          color: "error",
          subtitle: "",
        },
        {
          key: "recovered",
          label: "Valor Resgatado",
          value: this.formatCurrency(this.recoveredAmount),
          icon: "mdi-check-circle",
          color: "success",
          subtitle: "",
          info: "Valor recebido no período filtrado por meio da cobrança.",
        },
        {
          key: "critical",
          label: "Críticos",
          value: this.filteredCards.filter(
            (card) => card.priority === "critica",
          ).length,
          icon: "mdi-fire",
          color: "warning",
          subtitle: "",
        },
      ];
    },
    totalAmount() {
      return this.filteredCards.reduce(
        (total, card) => total + Number(card.valor_total_vencido || 0),
        0,
      );
    },
    recoveredAmount() {
      return this.recoveredAmountValue;
    },
    monthlyRecoveredAmount() {
      return this.recoveredAmountValue;
    },
    recoveryRemainingAmount() {
      return Math.max(
        Number(this.recoveryGoal || 0) - this.monthlyRecoveredAmount,
        0,
      );
    },
    recoveryProgressPercent() {
      const goal = Number(this.recoveryGoal || 0);
      if (goal <= 0) return 0;
      return Math.min((this.monthlyRecoveredAmount / goal) * 100, 100);
    },
    recoveryProgressLabel() {
      return `${Math.round(this.recoveryProgressPercent)}%`;
    },
    activeWhatsAppTemplates() {
      if (!this.whatsAppTemplates || !this.whatsAppTemplates.length) return [];
      const activeTemplates = this.whatsAppTemplates.filter(
        (template) =>
          template.status_cliente === "ATIVO" &&
          template.status_broker === "APPROVED",
      );
      if (!this.isWhatsAppPrevidaContext()) return activeTemplates;

      const defaultTemplateName = this.normalizarNomeEmpresa("PV_COBRANÇA_NOVO");
      return activeTemplates.filter((template) =>
        this.normalizarNomeEmpresa(template.name) === defaultTemplateName,
      );
    },
    whatsAppCompanyPhone() {
      const telefones = this.obterTelefonesEmpresa(this.selectedCompany);
      return telefones[0] ? telefones[0].numero : null;
    },
    whatsAppSearchLabel() {
      switch (this.whatsAppSearchType) {
        case "telefone":
          return "Numero de telefone";
        case "nome":
          return "Nome do cliente";
        case "cpf":
          return "CPF do cliente";
        default:
          return "Valor para busca";
      }
    },
    canSearchWhatsAppClient() {
      if (!this.whatsAppSearchValue) return false;
      if (this.whatsAppSearchType === "telefone") {
        return this.onlyDigits(this.whatsAppSearchValue).length >= 8;
      }
      return true;
    },
    whatsAppAllParametersFilled() {
      if (!this.whatsAppTemplate) return false;
      const params = this.extractTemplateParams(this.whatsAppTemplate.content);
      if (params.length === 0) return true;
      return this.whatsAppTemplateParams.every((param, index) => {
        return index >= params.length || (param && param.trim() !== "");
      });
    },
    canSendWhatsAppTemplate() {
      return (
        this.whatsAppFormValid &&
        !this.sendingWhatsAppMessage &&
        !this.checkingWhatsAppContact &&
        !!this.whatsAppPhoneNumber &&
        !!this.whatsAppTemplate &&
        this.whatsAppAllParametersFilled
      );
    },
    whatsAppClientsCount() {
      return this.whatsAppClients ? this.whatsAppClients.length : 0;
    },
    responsibleOptions() {
      const responsibles = [
        ...new Set(this.cards.map((card) => card.responsible).filter(Boolean)),
      ];
      return [
        { value: "todos", label: "Todos" },
        ...responsibles.map((responsible) => ({
          value: responsible,
          label: responsible,
        })),
      ];
    },
    activeCollaboratorOptions() {
      return this.activeCollaborators.map((collaborator) => ({
        value: collaborator.cpf,
        label: [collaborator.name, collaborator.role, collaborator.department]
          .filter(Boolean)
          .join(" "),
        name: collaborator.name,
        meta: [collaborator.role, collaborator.department]
          .filter(Boolean)
          .join(" • "),
      }));
    },
    loteOptions() {
      const lotes = [
        ...new Set(
          this.cards
            .map((card) => this.getCardLoteRef(card))
            .filter((loteRef) => loteRef && loteRef.trim() !== ""),
        ),
      ].sort((a, b) => a.localeCompare(b, "pt-BR", { numeric: true }));

      return [
        { value: "todos", label: "Todos" },
        ...lotes.map((loteRef) => ({
          value: loteRef,
          label: loteRef,
        })),
      ];
    },
    overdueInstallmentOptions() {
      const quantities = [
        ...new Set(
          this.cards
            .map((card) => this.getOverdueInstallments(card))
            .filter((quantity) => quantity > 0),
        ),
      ].sort((a, b) => a - b);

      return quantities.map((quantity) => ({
        value: quantity,
        label:
          quantity === 1
            ? "1 parcela vencida"
            : `${quantity} parcelas vencidas`,
      }));
    },
    contractTypeOptions() {
      const types = [
        ...new Set(
          this.cards
            .map((card) => this.getCardContractType(card))
            .filter((type) => type && type.trim() !== ""),
        ),
      ].sort((a, b) => a.localeCompare(b, "pt-BR", { numeric: true }));

      return types.map((type) => ({
        value: type,
        label: type,
      }));
    },
    priorityOptions() {
      return [
        { value: "todos", label: "Todos" },
        ...Object.keys(this.priorityMap).map((value) => ({
          value,
          label: this.priorityMap[value].label,
        })),
      ];
    },
    tagOptions() {
      const allTags = this.cards.flatMap((card) => this.getCardTags(card));
      const uniqueTags = allTags.filter(
        (tag, index, self) => index === self.findIndex((t) => t.id === tag.id),
      );
      return uniqueTags.map((tag) => ({
        value: tag.id,
        label: tag.nome,
      }));
    },
    customerDataItems() {
      if (!this.selectedCard) return [];

      return [
        {
          key: "phone",
          icon: "mdi-phone-outline",
          value: this.selectedCard.phone || "Telefone não informado",
        },
        {
          key: "email",
          icon: "mdi-email-outline",
          value: this.selectedCard.email || "E-mail não informado",
        },
        {
          key: "due",
          icon: "mdi-calendar-outline",
          value: `Data Interação: ${this.formatDate(
            this.selectedCard.dueDate,
          )}`,
        },
        {
          key: "operator",
          icon: "mdi-account-outline",
          value: `Responsável: ${
            this.selectedCard.operator || this.selectedCard.responsible
          }`,
        },
      ];
    },
    filteredInstallments() {
      if (!this.selectedCard) return [];
      const installments = this.getInstallments(this.selectedCard);
      if (this.installmentFilter === "todas") return installments;
      return installments.filter(
        (installment) => installment.status === this.installmentFilter,
      );
    },
    paginatedInstallments() {
      const start = (this.installmentsPage - 1) * this.installmentsPerPage;
      const end = start + this.installmentsPerPage;
      return this.filteredInstallments.slice(start, end);
    },
    totalInstallmentsPages() {
      return Math.ceil(
        this.filteredInstallments.length / this.installmentsPerPage,
      );
    },
    paginatedAgreements() {
      const agreements = this.getAgreements(this.selectedCard);
      const start = (this.agreementsPage - 1) * this.agreementsPerPage;
      const end = start + this.agreementsPerPage;
      return agreements.slice(start, end);
    },
    totalAgreementsPages() {
      const agreements = this.getAgreements(this.selectedCard);
      return Math.ceil(agreements.length / this.agreementsPerPage);
    },
    paginatedInteractions() {
      const start = (this.interactionsPage - 1) * this.interactionsPerPage;
      const end = start + this.interactionsPerPage;
      return this.filteredInteractionItems.slice(start, end);
    },
    totalInteractionsPages() {
      return Math.ceil(
        this.filteredInteractionItems.length / this.interactionsPerPage,
      );
    },
    interactionItems() {
      const ivertexItems = this.getInteractions(this.selectedCard).map(
        (interaction, index) => ({
          ...interaction,
          key: `ivertex-${interaction.id || index}`,
          type: "iVertex",
          channel: interaction.channel || "iVertex",
          responsible: interaction.responsible,
          date: interaction.date,
          dateLabel: this.formatDate(interaction.date),
          message: interaction.message || "-",
        }),
      );

      const whatsAppItems = this.getProtocols(this.selectedCard)
        .filter((protocol) => protocol.tipoExibicao !== "Ligacao")
        .map((protocol, index) => ({
          key: `whatsapp-${protocol.id || protocol.protocolNumber || index}`,
          type: "WhatsApp",
          channel: "WhatsApp",
          responsible: protocol.userInsert || protocol.userUpdate,
          date: protocol.dataUpdate || protocol.dataCreate,
          dateLabel: this.formatDateTime(
            protocol.dataUpdate || protocol.dataCreate,
          ),
          message: `Protocolo: ${protocol.protocolNumber || "-"}`,
          protocolNumber: protocol.protocolNumber || "-",
          protocol,
        }));

      const ligacaoItems = this.getProtocols(this.selectedCard)
        .filter((protocol) => protocol.tipoExibicao === "Ligacao")
        .map((protocol, index) => ({
          key: `ligacao-${protocol.id || protocol.protocolNumber || index}`,
          type: "Ligacao",
          channel: protocol.tipo || "PABX",
          responsible: protocol.agenteNome || protocol.agenteLogin,
          date: protocol.dtFim || protocol.dtInicio || protocol.dataUpdate,
          dateLabel: this.formatDateTime(
            protocol.dtFim || protocol.dtInicio || protocol.dataUpdate,
          ),
          message: this.getPabxProtocolMessage(protocol),
          protocolNumber: protocol.protocolNumber || protocol.protocolo || "-",
          protocol,
        }));

      return [...ivertexItems, ...whatsAppItems, ...ligacaoItems].sort((a, b) => {
        const dateA = new Date(a.date || 0).getTime();
        const dateB = new Date(b.date || 0).getTime();
        return dateB - dateA;
      });
    },
    filteredInteractionItems() {
      if (this.protocolTypeFilter === "todos") return this.interactionItems;
      return this.interactionItems.filter(
        (interaction) => interaction.type === this.protocolTypeFilter,
      );
    },
  },
  mounted() {
    this.setDefaultDateRange();
    this.loadInitialData();
    this.loadAvailableTags();
  },
  watch: {
    "filters.responsible"() {
      if (this.hasAppliedRequiredFilters && this.canLoadCards()) {
        this.loadRecoveredAmount();
      }
    },
  },
  methods: {
    async loadInitialData() {
      this.isLoading = true;
      try {
        this.loadBoard();
        await this.loadColumns();
        this.loadCompanies();

        if (this.companyOptions.length === 1 && this.canLoadCards()) {
          await this.loadRecoveryGoal();
          await this.loadCards();
          this.hasAppliedRequiredFilters = true;
          this.filterAlert = "";
        } else {
          this.filterAlert =
            "Selecione uma empresa e um período para carregar o fluxo de cobrança.";
        }
      } catch (error) {
        console.error(
          "Erro ao carregar estrutura do fluxo de cobranca:",
          error,
        );
      } finally {
        this.isLoading = false;
      }
    },
    async loadAvailableTags() {
      try {
        const response = await fluxoCobrancaService.getTags();
        this.availableTags = response.data?.data || response.data || [];
        console.log("Tags disponíveis:", this.availableTags);
      } catch (error) {
        console.error("Erro ao carregar tags disponíveis:", error);
      }
    },
    async init() {
      if (!this.canLoadCards()) return;

      this.isLoading = true;
      try {
        this.loadBoard();
        await this.loadColumns();
        this.loadCompanies();
        await this.loadRecoveryGoal();
        await this.loadCards();
        await this.loadRecoveredAmount();
        this.hasAppliedRequiredFilters = true;
        this.filterAlert = "";
      } catch (error) {
        console.error("Erro ao carregar fluxo de cobranca:", error);
      } finally {
        this.isLoading = false;
      }
    },
    async applyRequiredFilters() {
      await this.init();
    },
    loadBoard() {
      this.board = {
        id: 1,
        title: "Fluxo de Cobrança",
        subtitle: "Gestão de cobranças e inadimplência",
        updatedAt: new Date().toISOString(),
      };
    },
    async loadColumns() {
      const response = await fluxoCobrancaService.getColumns();
      if (response.status === 200) {
        this.columns = this.getResponseData(response);
      }
    },
    loadCompanies() {
      const empresas = [
        "A FLOR DO CAFÉ",
        "CEMITERIO PREVIDA",
        "CEMITERIO PREVIDA SÃO MIGUEL",
        "MEMORIAL PARQUE MACEIÓ",
        "PARQUE DAS FLORES",
        "PARQUE DO AGRESTE",
        "PREVIDA",
      ];

      const empresasFiltradas = empresas.filter((empresa) =>
        this.hasPermission(empresa),
      );

      this.companyOptions = empresasFiltradas.map((empresa) => ({
        text: empresa,
        value: empresa,
      }));

      // Selecionar automaticamente se houver apenas uma empresa disponível
      if (empresasFiltradas.length === 1) {
        this.selectedCompany = empresasFiltradas[0];
      } else if (
        this.selectedCompany &&
        !empresasFiltradas.includes(this.selectedCompany)
      ) {
        this.selectedCompany = "";
      }
    },
    async loadCards() {
      if (!this.canFilterResponsible) {
        this.filters.responsible = "todos";
        this.filters.loteRef = "todos";
      }

      const response = await fluxoCobrancaService.getCards({
        dataInicio: this.selectedStartDateISO,
        dataFim: this.selectedEndDateISO,
        empresa: this.selectedCompany,
      });
      if (response.status === 200) {
        this.cards = this.getResponseData(response);
        this.initializeColumnLimits();
      }
    },
    async loadActiveCollaborators() {
      if (!this.selectedCompany) {
        this.activeCollaborators = [];
        return;
      }

      this.loadingCollaborators = true;
      try {
        const response = await fluxoCobrancaService.getCollaborators({
          empresa: this.selectedCompany,
        });
        this.activeCollaborators = this.getResponseData(response);
      } catch (error) {
        console.error("Erro ao carregar colaboradores ativos:", error);
        this.activeCollaborators = [];
        this.showSnackbar(
          error.response?.data?.message ||
            "Erro ao carregar colaboradores ativos.",
          "error",
        );
      } finally {
        this.loadingCollaborators = false;
      }
    },
    async loadRecoveryGoal() {
      this.loadingRecoveryGoal = true;
      try {
        const response = await fluxoCobrancaService.getMeta({
          dataInicio: this.selectedStartDateISO,
          dataFim: this.selectedEndDateISO,
          empresa: this.selectedCompany,
        });
        const payload =
          response && response.data && response.data.data !== undefined
            ? response.data.data
            : response.data;
        this.recoveryGoal = this.extractMetaValue(payload);
      } catch (error) {
        console.error("Erro ao carregar meta mensal de recuperacao:", error);
        this.recoveryGoal = 0;
      } finally {
        this.loadingRecoveryGoal = false;
      }
    },
    async loadRecoveredAmount() {
      this.loadingRecoveredAmount = true;
      try {
        const response = await fluxoCobrancaService.getRecoveredAmount({
          dataInicio: this.selectedStartDateISO,
          dataFim: this.selectedEndDateISO,
          empresa: this.selectedCompany,
          responsavel: this.canFilterResponsible
            ? this.filters.responsible
            : "todos",
        });
        const payload =
          response && response.data && response.data.data !== undefined
            ? response.data.data
            : response.data;
        this.recoveredAmountValue = this.extractRecoveredAmount(payload);
      } catch (error) {
        console.error("Erro ao carregar valor resgatado:", error);
        this.recoveredAmountValue = 0;
      } finally {
        this.loadingRecoveredAmount = false;
      }
    },
    extractRecoveredAmount(payload) {
      if (Array.isArray(payload)) {
        return this.extractRecoveredAmount(payload[0]);
      }

      if (payload && typeof payload === "object") {
        const value =
          payload.valorResgatado ??
          payload.valor_resgatado ??
          payload.valor ??
          payload.total;
        return this.extractMetaValue(value);
      }

      return this.extractMetaValue(payload);
    },
    extractMetaValue(payload) {
      if (Array.isArray(payload)) {
        return this.extractMetaValue(payload[0]);
      }

      if (payload && typeof payload === "object") {
        const value =
          payload.meta ??
          payload.valor ??
          payload.valorMeta ??
          payload.valor_meta ??
          payload.metaMensal ??
          payload.meta_mensal ??
          payload.metaMensalRecuperacao ??
          payload.meta_mensal_recuperacao;

        return this.extractMetaValue(value);
      }

      if (typeof payload === "number") return payload;
      if (typeof payload !== "string") return 0;

      const numericText = payload.replace(/[^\d,.-]/g, "");
      if (!numericText) return 0;

      const normalized = numericText.includes(",")
        ? numericText.replace(/\./g, "").replace(",", ".")
        : numericText;

      return Number(normalized) || 0;
    },
    getResponseData(response) {
      if (!response || !response.data) return [];
      return response.data.data || response.data;
    },
    getCardText(value) {
      return String(value || "").toLowerCase();
    },
    getCardLoteRef(card) {
      return (card && (card.loteRef || card.lote_ref)) || "";
    },
    getCardContractType(card) {
      return (
        (card &&
          (card.contractType ||
            card.tipoContrato ||
            card.tipo_contrato ||
            card.tipoContratoNome)) ||
        ""
      );
    },
    isCardFalecido(card) {
      return Boolean(card && (card.isFalecido || card.is_falecido));
    },
    getColumnColor(stageId) {
      const column = this.columns.find((item) => item.id === stageId);
      return column?.color || "#64748b";
    },
    getCardTags(card) {
      return Array.isArray(card && card.tags) ? card.tags : [];
    },
    getTagTextColor(tag) {
      const fallback = (tag && tag.texto_cor) || "black";
      const hex = String((tag && tag.cor) || "")
        .trim()
        .replace(/^#/, "");
      if (!/^([0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(hex)) {
        return fallback;
      }

      const fullHex =
        hex.length <= 4
          ? hex
              .slice(0, 3)
              .split("")
              .map((char) => char + char)
              .join("")
          : hex.slice(0, 6);
      const [r, g, b] = [0, 2, 4].map((index) => {
        const channel = parseInt(fullHex.substr(index, 2), 16) / 255;
        return channel <= 0.03928
          ? channel / 12.92
          : Math.pow((channel + 0.055) / 1.055, 2.4);
      });
      const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
      const contrastWithWhite = 1.05 / (luminance + 0.05);
      const contrastWithBlack = (luminance + 0.05) / 0.05;

      return contrastWithBlack >= contrastWithWhite ? "black" : "white";
    },
    getStageHistory(card) {
      return Array.isArray(card && card.stageHistory) ? card.stageHistory : [];
    },
    getProtocols(card) {
      return Array.isArray(card && card.protocols) ? card.protocols : [];
    },
    matchesLastContactFilter(card) {
      const filter = this.filters.lastContact;
      if (!filter || filter === "todos") return true;

      const days = this.getDaysSinceLastContact(card);
      if (filter === "never") return days === null;
      if (days === null) return false;

      const threshold = Number(filter);
      if (threshold === 120) return days > 120;
      return days >= threshold;
    },
    getDaysSinceLastContact(card) {
      if (!card || !card.lastContactAt) return null;

      const lastContact = new Date(card.lastContactAt);
      if (Number.isNaN(lastContact.getTime())) return null;

      const today = new Date();
      today.setHours(0, 0, 0, 0);
      lastContact.setHours(0, 0, 0, 0);

      return Math.max(
        0,
        Math.floor((today.getTime() - lastContact.getTime()) / 86400000),
      );
    },
    getLastContactLabel(card) {
      const days = this.getDaysSinceLastContact(card);
      if (days === null) return "Nunca contatado";

      const date = this.formatDate(card.lastContactAt);
      if (days === 0) return `${date} - hoje`;
      if (days === 1) return `${date} - há 1 dia`;
      if (days < 30) return `${date} - há ${days} dias`;

      const months = Math.floor(days / 30);
      if (months === 1) return `${date} - há 1 mês`;
      if (months < 12) return `${date} - há ${months} meses`;

      const years = Math.floor(months / 12);
      return years === 1 ? `${date} - há 1 ano` : `${date} - há ${years} anos`;
    },
    isRecoveredCard(card) {
      const stageName = this.getCardText(card && card.stageName);
      const stageType = this.getCardText(card && card.stageType);
      return stageName === "pago / quitado" || stageType === "finalizado";
    },
    getPriorityConfig(priority) {
      return (
        this.priorityMap[priority] || {
          label: priority || "Sem prioridade",
          color: "grey lighten-3",
          textColor: "grey darken-3",
        }
      );
    },
    getInstallmentStatusConfig(status) {
      return (
        this.installmentStatusMap[status] || {
          label: status || "sem status",
          color: "grey",
        }
      );
    },
    canLoadCards() {
      if (
        !this.selectedCompany ||
        !this.selectedStartDateISO ||
        !this.selectedEndDateISO
      ) {
        this.hasAppliedRequiredFilters = false;
        this.cards = [];
        this.filterAlert =
          "Informe empresa, data inicial e data final antes de carregar os dados.";
        return false;
      }

      if (
        new Date(this.selectedStartDateISO) > new Date(this.selectedEndDateISO)
      ) {
        this.hasAppliedRequiredFilters = false;
        this.cards = [];
        this.filterAlert =
          "A data inicial não pode ser maior que a data final.";
        return false;
      }

      return true;
    },
    setDefaultDateRange() {
      const today = new Date();
      const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);

      this.selectedStartDateISO = this.formatDateInput(firstDay);
      this.selectedEndDateISO = this.formatDateInput(today);
      this.selectedStartDate = this.formatDateBR(firstDay);
      this.selectedEndDate = this.formatDateBR(today);
    },
    formatDateInput(value) {
      const date = new Date(value);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    getCardsByColumn(columnId) {
      return this.filteredCards.filter((card) => card.stage === columnId);
    },
    getVisibleCardsByColumn(columnId) {
      const cards = this.getCardsByColumn(columnId);
      const limit =
        this.columnCardsLimit[columnId] || this.initialCardsPerColumn;
      return cards.slice(0, limit);
    },
    hasMoreCards(columnId) {
      const cards = this.getCardsByColumn(columnId);
      const limit =
        this.columnCardsLimit[columnId] || this.initialCardsPerColumn;
      return cards.length > limit;
    },
    loadMoreCards(columnId) {
      const currentLimit =
        this.columnCardsLimit[columnId] || this.initialCardsPerColumn;
      this.$set(
        this.columnCardsLimit,
        columnId,
        currentLimit + this.cardsIncrement,
      );
    },
    initializeColumnLimits() {
      this.columnCardsLimit = {};
      this.columns.forEach((column) => {
        this.$set(this.columnCardsLimit, column.id, this.initialCardsPerColumn);
      });
    },
    getColumnTotal(columnId) {
      if (this.isPaidColumn(columnId)) {
        return this.getCardsByColumn(columnId).reduce(
          (total, card) => total + this.getCardPaidAmount(card),
          0,
        );
      }

      return this.getCardsByColumn(columnId).reduce(
        (total, card) => total + Number(card.valor_total_vencido || 0),
        0,
      );
    },
    buildTicketExportParams() {
      return {
        dataInicio: this.selectedStartDateISO,
        dataFim: this.selectedEndDateISO,
        empresa: this.selectedCompany,
        responsavel: this.canFilterResponsible
          ? this.filters.responsible
          : "todos",
        loteRef: this.canFilterResponsible ? this.filters.loteRef : "todos",
        search: this.filters.search || "",
        prioridade: this.filters.priority || "todos",
        ultimoContato: this.filters.lastContact || "todos",
        tags: Array.isArray(this.filters.tag) ? this.filters.tag.join(",") : "",
      };
    },
    async exportTicketsXls() {
      if (
        this.exportingTickets ||
        !this.hasAppliedRequiredFilters ||
        !this.filteredCards.length
      ) {
        return;
      }
      if (!this.canLoadCards()) return;

      this.exportingTickets = true;
      try {
        const response = await fluxoCobrancaService.exportCardsXls(
          this.buildTicketExportParams(),
        );
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `fluxo_cobranca_${Date.now()}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Erro ao exportar fluxo de cobrança:", error);
        this.showSnackbar("Erro ao exportar a lista de cobrança.", "error");
      } finally {
        this.exportingTickets = false;
      }
    },
    getCobrancaStageId(stageOrColumn) {
      const rawId =
        typeof stageOrColumn === "object"
          ? stageOrColumn?.id ?? stageOrColumn?.stage ?? stageOrColumn?.etapa_id
          : stageOrColumn;
      const stageId = Number(rawId);
      return Number.isFinite(stageId) ? stageId : null;
    },
    isCobrancaStage(stageOrColumn, stageKey) {
      return (
        this.getCobrancaStageId(stageOrColumn) === COBRANCA_STAGE_IDS[stageKey]
      );
    },
    isPaidColumn(columnId) {
      return this.isCobrancaStage(columnId, "PAGO_QUITADO");
    },
    getCardPaidAmount(card) {
      const receivedDocuments =
        card.receivedDocuments ||
        card.documentosRecebidos ||
        card.documentos_recebidos ||
        [];

      if (!Array.isArray(receivedDocuments)) {
        return 0;
      }

      return receivedDocuments.reduce(
        (total, document) =>
          total + Number(document.valorPago || document.valor_pago || 0),
        0,
      );
    },
    isPromessaPagamentoStage(stageOrColumn) {
      return this.isCobrancaStage(stageOrColumn, "PROMESSA_PAGAMENTO");
    },
    isStageBeforePromessaPagamento(stageOrColumn) {
      const stageId = this.getCobrancaStageId(stageOrColumn);
      const stage = this.columns.find((column) => column.id === stageId);
      const promessa = this.columns.find((column) =>
        this.isPromessaPagamentoStage(column),
      );

      if (stage && promessa && stage.order && promessa.order) {
        return stage.order < promessa.order;
      }

      return stageId !== null && stageId < COBRANCA_STAGE_IDS.PROMESSA_PAGAMENTO;
    },
    shouldConfirmRenegotiationUnlink(card, targetStage) {
      return (
        !!card &&
        this.isPromessaPagamentoStage(card.stage) &&
        !!card.renegId &&
        this.isStageBeforePromessaPagamento(targetStage)
      );
    },
    openRenegotiationUnlinkDialog(card, targetStage, reloadOnCancel = false) {
      this.pendingUnlinkRenegCard = card;
      this.pendingUnlinkRenegStage = targetStage;
      this.pendingUnlinkRenegReloadOnCancel = reloadOnCancel;
      this.unlinkRenegDialog = true;
    },
    closeRenegotiationUnlinkDialog() {
      this.unlinkRenegDialog = false;
      this.unlinkRenegLoading = false;
      this.pendingUnlinkRenegCard = null;
      this.pendingUnlinkRenegStage = null;
      this.pendingUnlinkRenegReloadOnCancel = false;
    },
    async cancelRenegotiationUnlink() {
      const shouldReload = this.pendingUnlinkRenegReloadOnCancel;
      this.closeRenegotiationUnlinkDialog();
      if (shouldReload) {
        await this.loadCards();
      }
    },
    async confirmRenegotiationUnlink() {
      if (!this.pendingUnlinkRenegCard || !this.pendingUnlinkRenegStage) return;

      const selectedCardId = this.pendingUnlinkRenegCard.id;
      const targetStage = this.pendingUnlinkRenegStage;
      this.unlinkRenegLoading = true;

      try {
        await fluxoCobrancaService.updateCardStage(selectedCardId, targetStage);
        await this.loadCards();
        const updatedCard = this.cards.find((card) => card.id === selectedCardId);
        if (this.selectedCard && this.selectedCard.id === selectedCardId) {
          this.selectedCard = updatedCard || this.selectedCard;
        }
        this.showSnackbar("Renegociação desvinculada do ticket.", "success");
        this.closeRenegotiationUnlinkDialog();
      } catch (error) {
        await this.loadCards();
        this.showSnackbar(
          error.response?.data?.message || "Erro ao mover o ticket.",
          "error",
        );
        this.closeRenegotiationUnlinkDialog();
      }
    },
    canChangeRenegotiation(card) {
      return !!card && this.isPromessaPagamentoStage(card.stage);
    },
    async handleCardStageChange(event, column) {
      if (!event.added) return;

      const card = event.added.element;
      if (this.shouldConfirmRenegotiationUnlink(card, column.id)) {
        this.openRenegotiationUnlinkDialog(card, column.id, true);
        return;
      }

      if (this.isPromessaPagamentoStage(column)) {
        await this.openRenegotiationDialog(card, column.id, "move");
        return;
      }

      try {
        await fluxoCobrancaService.updateCardStage(card.id, column.id);
        await this.loadCards();
      } catch (error) {
        await this.loadCards();
        this.showSnackbar(
          error.response?.data?.message || "Erro ao mover o ticket.",
          "error",
        );
      }
    },
    async openRenegotiationDialog(card, stage, mode = "move") {
      if (!card) return;

      this.pendingRenegCard = card;
      this.pendingRenegStage = stage;
      this.renegDialogMode = mode;
      this.renegotiations = [];
      this.selectedRenegotiationId = null;
      this.renegDialog = true;
      this.loadingRenegotiations = true;

      try {
        const response = await fluxoCobrancaService.getRenegotiations(card.id);
        const renegotiations = response.data?.data || response.data || [];
        this.renegotiations = Array.isArray(renegotiations)
          ? renegotiations
          : [];

        const currentReneg = this.renegotiations.find(
          (reneg) => String(reneg.id) === String(card.renegId),
        );
        this.selectedRenegotiationId =
          (currentReneg && currentReneg.id) ||
          (this.renegotiations[0] && this.renegotiations[0].id) ||
          null;
      } catch (error) {
        console.error("Erro ao buscar renegociações:", error);
        this.showSnackbar(
          error.response?.data?.message || "Erro ao buscar renegociações.",
          "error",
        );
        this.renegotiations = [];
      } finally {
        this.loadingRenegotiations = false;
      }
    },
    async confirmRenegotiationSelection() {
      if (!this.pendingRenegCard || !this.selectedRenegotiationId) return;

      this.savingRenegotiation = true;
      const selectedCardId = this.pendingRenegCard.id;

      try {
        if (this.renegDialogMode === "edit") {
          await fluxoCobrancaService.assignRenegotiation(
            selectedCardId,
            this.selectedRenegotiationId,
          );
        } else {
          await fluxoCobrancaService.updateCardStage(
            selectedCardId,
            this.pendingRenegStage,
            { renegId: this.selectedRenegotiationId },
          );
        }

        await this.loadCards();
        const updatedCard = this.cards.find(
          (card) => card.id === selectedCardId,
        );
        if (this.selectedCard && this.selectedCard.id === selectedCardId) {
          this.selectedCard = updatedCard || this.selectedCard;
        }
        this.showSnackbar("Renegociação vinculada ao card.", "success");
        this.closeRenegotiationDialog();
      } catch (error) {
        console.error("Erro ao salvar renegociação:", error);
        this.showSnackbar(
          error.response?.data?.message || "Erro ao salvar renegociação.",
          "error",
        );
      } finally {
        this.savingRenegotiation = false;
      }
    },
    async cancelRenegotiationDialog() {
      const shouldReload = this.renegDialogMode === "move";
      this.closeRenegotiationDialog();
      if (shouldReload) {
        await this.loadCards();
      }
    },
    closeRenegotiationDialog() {
      this.renegDialog = false;
      this.renegotiations = [];
      this.selectedRenegotiationId = null;
      this.pendingRenegCard = null;
      this.pendingRenegStage = null;
      this.renegDialogMode = "move";
    },
    async selectCard(card) {
      console.log(card)
      this.selectedCard = card;
      this.detailTab = 0;
      this.installmentFilter = "todas";
      this.installmentsPage = 1;
      this.agreementsPage = 1;
      this.interactionsPage = 1;
      this.protocolTypeFilter = "todos";
      this.expandedInteractionKeys = [];
      this.detailDialog = true;

      // Carregar dados detalhados do ticket
      await this.loadCardDetails(card.id);
    },
    async openResponsibleDialog(card) {
      if (!card || !this.selectedCompany) {
        this.showSnackbar(
          "Selecione uma empresa no filtro antes de substituir o responsável.",
          "warning",
        );
        return;
      }

      this.pendingResponsibleCard = card;
      this.selectedResponsibleCpf = card.cpf_cnpj_responsavel || null;
      this.responsibleDialog = true;
      await this.loadActiveCollaborators();
    },
    closeResponsibleDialog() {
      this.responsibleDialog = false;
      this.savingResponsible = false;
      this.pendingResponsibleCard = null;
      this.selectedResponsibleCpf = null;
    },
    async confirmResponsibleChange() {
      if (!this.pendingResponsibleCard || !this.selectedResponsibleCpf) return;

      const selectedCardId = this.pendingResponsibleCard.id;
      this.savingResponsible = true;
      try {
        const response = await fluxoCobrancaService.assignResponsible(
          selectedCardId,
          this.selectedResponsibleCpf,
          this.selectedCompany,
        );
        const updatedCard = this.getResponseData(response);
        const cardIndex = this.cards.findIndex(
          (card) => card.id === selectedCardId,
        );

        if (cardIndex !== -1) {
          this.$set(this.cards, cardIndex, {
            ...this.cards[cardIndex],
            ...updatedCard,
          });
        }
        if (this.selectedCard && this.selectedCard.id === selectedCardId) {
          this.selectedCard = {
            ...this.selectedCard,
            ...updatedCard,
          };
        }

        this.showSnackbar("Responsável substituído com sucesso.", "success");
        this.closeResponsibleDialog();
      } catch (error) {
        this.showSnackbar(
          error.response?.data?.message || "Erro ao substituir responsável.",
          "error",
        );
      } finally {
        this.savingResponsible = false;
      }
    },
    async loadCardDetails(ticketId) {
      this.loadingCardDetails = true;
      try {
        console.log("=== Carregando detalhes do ticket:", ticketId, "===");

        const ticketResponse = await fluxoCobrancaService.getCard(ticketId);
        console.log("0. Ticket completo:", ticketResponse.data);

        // 1. Carregar Tags
        const tagsResponse = await fluxoCobrancaService.getCardTags(ticketId);
        console.log("1. Tags do ticket:", tagsResponse.data);

        // 2. Carregar Parcelas
        const parcelasResponse = await fluxoCobrancaService.getInstallments(
          ticketId,
        );
        console.log("2. Parcelas do ticket:", parcelasResponse.data);

        // 3. Carregar Acordos
        const acordosResponse = await fluxoCobrancaService.getAgreements(
          ticketId,
        );
        console.log("3. Acordos do ticket:", acordosResponse.data);

        // 4. Carregar Interações
        const interacoesResponse = await fluxoCobrancaService.getInteractions(
          ticketId,
        );
        console.log("4. Interações do ticket:", interacoesResponse.data);

        // 5. Carregar Sinistros
        const sinistrosResponse = await fluxoCobrancaService.getClaims(
          ticketId,
        );
        console.log("5. Sinistros do ticket:", sinistrosResponse.data);

        // 6. Carregar Protocolos
        const protocolosResponse = await fluxoCobrancaService.getProtocols(
          ticketId,
        );
        console.log("6. Protocolos do ticket:", protocolosResponse.data);

        // Atualizar o card selecionado com os dados carregados
        if (this.selectedCard && this.selectedCard.id === ticketId) {
          const ticketDetalhado =
            ticketResponse.data?.data || ticketResponse.data || {};
          this.selectedCard = {
            ...this.selectedCard,
            ...ticketDetalhado,
            tags: tagsResponse.data?.data || tagsResponse.data || [],
            installments:
              parcelasResponse.data?.data || parcelasResponse.data || [],
            agreements:
              acordosResponse.data?.data || acordosResponse.data || [],
            interactions:
              interacoesResponse.data?.data || interacoesResponse.data || [],
            claims:
              sinistrosResponse.data?.data || sinistrosResponse.data || [],
            protocols:
              protocolosResponse.data?.data || protocolosResponse.data || [],
          };
        }
      } catch (error) {
        console.error("Erro ao carregar detalhes do ticket:", error);
      } finally {
        this.loadingCardDetails = false;
      }
    },
    clearFilters() {
      this.filters = {
        search: "",
        responsible: "todos",
        priority: "todos",
        lastContact: "todos",
        overdueInstallments: [],
        contractType: [],
        loteRef: "todos",
        tag: [],
      };
    },
    formatCurrency(value) {
      return Number(value || 0).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
    formatDate(value) {
      if (!value) return "-";
      return new Date(value).toLocaleDateString("pt-BR");
    },
    formatDateTime(value) {
      if (!value) return "-";
      return new Date(value).toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    getProtocolStatusColor(protocol) {
      return protocol && protocol.status === "closed" ? "green" : "warning";
    },
    getProtocolStatusLabel(protocol) {
      return protocol && protocol.status === "closed" ? "Concluido" : "Aberto";
    },
    formatDuration(seconds) {
      const totalSeconds = Number(seconds || 0);
      const minutes = Math.floor(totalSeconds / 60);
      const remainingSeconds = totalSeconds % 60;
      return `${minutes}min ${String(remainingSeconds).padStart(2, "0")}s`;
    },
    getPabxProtocolMessage(protocol) {
      const parts = [
        `Protocolo: ${protocol.protocolNumber || protocol.protocolo || "-"}`,
        `Status: ${protocol.status || "-"}`,
        `Atendido: ${protocol.atendido || "-"}`,
        `Duracao: ${this.formatDuration(protocol.duracaoSegundos)}`,
      ];
      if (protocol.tabulacaoDescricao) {
        parts.push(`Tabulacao: ${protocol.tabulacaoDescricao}`);
      }
      return parts.join(" | ");
    },
    async openProtocolMessages(protocol) {
      if (!this.selectedCard || !protocol || !protocol.protocolNumber) return;

      this.selectedProtocol = protocol;
      this.selectedProtocolMessages = [];
      this.protocolMessagesDialog = true;
      this.protocolMessagesLoading = true;

      try {
        const response = await fluxoCobrancaService.getProtocolMessages(
          this.selectedCard.id,
          protocol.protocolNumber,
        );
        this.selectedProtocolMessages =
          response.data?.data || response.data || [];
      } catch (error) {
        console.error("Erro ao carregar mensagens do protocolo:", error);
        this.showSnackbar(
          error.response?.data?.message ||
            "Erro ao carregar mensagens do protocolo.",
          "error",
        );
      } finally {
        this.protocolMessagesLoading = false;
      }
    },
    closeProtocolMessagesDialog() {
      this.protocolMessagesDialog = false;
      this.selectedProtocol = null;
      this.selectedProtocolMessages = [];
    },
    isOutgoingProtocolMessage(message) {
      const direction = String(
        message && message.direction ? message.direction : "",
      ).toLowerCase();
      return direction === "outgoing" || direction === "out";
    },
    getProtocolMessageText(message) {
      const text =
        (message && (message.message || message.caption || message.content)) ||
        "";
      if (typeof document === "undefined") return String(text);

      const element = document.createElement("div");
      element.innerHTML = String(text);
      return element.textContent || element.innerText || "";
    },
    formatCpfMasked(value) {
      if (!value) return "Documento não informado";
      const cpf = this.onlyDigits(value);
      if (cpf.length !== 11) return value;
      return `${cpf.substring(0, 3)}.***.**${cpf.substring(9, 11)}`;
    },
    getVencimentoColor(dataVencimento, status) {
      if (!dataVencimento) return "grey";

      if (
        status &&
        (status.toLowerCase().includes("pago") ||
          status.toLowerCase().includes("quitado"))
      ) {
        return "success";
      }

      const hoje = new Date();
      const vencimento = new Date(dataVencimento);

      return vencimento < hoje ? "error" : "success";
    },
    getVencimentoStatus(dataVencimento, status) {
      if (!dataVencimento) return "Sem data";

      if (
        status &&
        (status.toLowerCase().includes("pago") ||
          status.toLowerCase().includes("quitado"))
      ) {
        return status;
      }

      const hoje = new Date();
      const vencimento = new Date(dataVencimento);

      return vencimento < hoje ? "Vencido" : "A vencer";
    },
    getPlanMonthlyAmount(card) {
      if (card.plan && card.plan.monthlyAmount) return card.plan.monthlyAmount;
      return card.amount;
    },
    getClaims(card) {
      return card.claims || [];
    },
    getInstallments(card) {
      return card.installments || [];
    },
    getOverdueInstallments(card) {
      return Number(
        card?.overdueInstallments ??
          card?.quantidade_parcelas_vencidas ??
          0,
      );
    },
    getOverdueInstallmentsLabel(card) {
      const total = this.getOverdueInstallments(card);
      return total === 1 ? "1 parcela vencida" : `${total} parcelas vencidas`;
    },
    getAgreements(card) {
      return card.agreements || [];
    },
    getInteractions(card) {
      return card.interactions || [];
    },
    isInteractionExpanded(key) {
      return this.expandedInteractionKeys.includes(key);
    },
    toggleInteractionExpansion(key) {
      if (this.isInteractionExpanded(key)) {
        this.expandedInteractionKeys = this.expandedInteractionKeys.filter(
          (interactionKey) => interactionKey !== key,
        );
        return;
      }

      this.expandedInteractionKeys = [...this.expandedInteractionKeys, key];
    },
    getDelayLabel(card) {
      const days = Number(card.delayDays || 0);
      if (days === 0) return "0 dias em atraso";
      if (days === 1) return "1 dia em atraso";
      return `${days} dias em atraso`;
    },
    getOpenInstallmentsLabel(card) {
      const total = Number(card.openInstallments || 0);
      if (total === 1) return "1 parcela em aberto";
      return `${total} parcelas em aberto`;
    },
    getInteractionIcon(channel) {
      const icons = {
        WhatsApp: "mdi-whatsapp",
        Sms: "mdi-send-outline",
        SMS: "mdi-send-outline",
        Ligacao: "mdi-phone-outline",
        PABX: "mdi-phone-outline",
        "E-mail": "mdi-email-outline",
      };
      return icons[channel] || "mdi-message-text-outline";
    },
    getNextStage(card) {
      const currentIndex = this.orderedColumns.findIndex(
        (column) => column.id === card.stage,
      );
      if (currentIndex === -1) return this.orderedColumns[0];
      return (
        this.orderedColumns[currentIndex + 1] ||
        this.orderedColumns[currentIndex]
      );
    },
    getNextStageTitle(card) {
      const nextStage = this.getNextStage(card);
      return nextStage ? nextStage.title : "-";
    },
    async moveSelectedCardToStage(stage) {
      if (!this.selectedCard || this.selectedCard.stage === stage) return;

      if (this.shouldConfirmRenegotiationUnlink(this.selectedCard, stage)) {
        this.openRenegotiationUnlinkDialog(this.selectedCard, stage, false);
        return;
      }

      if (this.isPromessaPagamentoStage(stage)) {
        await this.openRenegotiationDialog(this.selectedCard, stage, "move");
        return;
      }

      const selectedCardId = this.selectedCard.id;
      try {
        await fluxoCobrancaService.updateCardStage(selectedCardId, stage);
        await this.loadCards();
        this.selectedCard = this.cards.find(
          (card) => card.id === selectedCardId,
        );
      } catch (error) {
        await this.loadCards();
        this.selectedCard = this.cards.find(
          (card) => card.id === selectedCardId,
        );
        this.showSnackbar(
          error.response?.data?.message || "Erro ao mover o ticket.",
          "error",
        );
      }
    },
    async advanceSelectedCard() {
      if (!this.selectedCard) return;
      const nextStage = this.getNextStage(this.selectedCard);
      if (!nextStage || nextStage.id === this.selectedCard.stage) return;

      await this.moveSelectedCardToStage(nextStage.id);
    },
    alternarVisibilidade() {
      this.mostrarFiltro = !this.mostrarFiltro;
    },
    limparFiltro() {
      this.selectedCompany = "";
      this.setDefaultDateRange();
      this.hasAppliedRequiredFilters = false;
      this.cards = [];
      this.recoveryGoal = 0;
      this.recoveredAmountValue = 0;
      this.filters.responsible = "todos";
    },
    handleStartDateSelection() {
      this.selectedStartDate = this.convertToBR(this.selectedStartDateISO);
      this.isStartDatePickerOpen = false;
    },
    handleEndDateSelection() {
      this.selectedEndDate = this.convertToBR(this.selectedEndDateISO);
      this.isEndDatePickerOpen = false;
    },
    convertToBR(dateString) {
      if (!dateString) return "";
      const [year, month, day] = dateString.split("-");
      return `${day}/${month}/${year}`;
    },
    convertToISO(dateString) {
      if (!dateString) return "";
      const [day, month, year] = dateString.split("/");
      return `${year}-${month}-${day}`;
    },
    formatDateBR(date) {
      if (!date) return "";
      const parsedDate = new Date(date);
      const day = String(parsedDate.getDate()).padStart(2, "0");
      const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
      const year = parsedDate.getFullYear();
      return `${day}/${month}/${year}`;
    },
    hasPermission(empresa) {
      const roles = this.getUserRoles();

      if (roles.includes("ROLE_ADMIN")) {
        return true;
      }

      const requiredRoles = empresa.split(",").flatMap((name) => {
        const roleName = name.trim().toUpperCase().replace(/\s/g, "_");
        return [`ROLE_${roleName}`, `ROLE_${this.removeAccents(roleName)}`];
      });

      return requiredRoles.some((role) => roles.includes(role));
    },
    getUserRoles() {
      const user = JSON.parse(sessionStorage.getItem("user") || "{}");
      return Array.isArray(user.roles) ? user.roles : [];
    },
    removeAccents(value) {
      return String(value || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    },
    normalizarTexto(value) {
      return this.removeAccents(value).trim().toLowerCase();
    },
    showSnackbar(text, color = "info", timeout = 3000) {
      this.snackbar = {
        show: true,
        text,
        color,
        timeout,
      };
    },
    onlyDigits(value) {
      return String(value || "").replace(/\D/g, "");
    },
    formatCpf(value) {
      const cpf = this.onlyDigits(value);
      if (cpf.length !== 11) return value || "";
      return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    },
    normalizarNomeEmpresa(empresa) {
      return String(empresa || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toUpperCase()
        .trim();
    },
    isWhatsAppPrevidaContext() {
      const empresaSelecionada = this.normalizarNomeEmpresa(
        this.selectedCompany,
      );
      const empresaCard = this.normalizarNomeEmpresa(
        this.whatsAppSourceCard?.company ||
          this.whatsAppSourceCard?.empresa ||
          this.whatsAppSourceCard?.empresa_nome,
      );

      return empresaSelecionada === "PREVIDA" || empresaCard === "PREVIDA";
    },
    selectDefaultWhatsAppTemplate() {
      if (!this.isWhatsAppPrevidaContext()) return;

      const defaultTemplateName = this.normalizarNomeEmpresa(
        "PV_COBRANÇA_NOVO",
      );
      const template = this.activeWhatsAppTemplates.find(
        (item) => this.normalizarNomeEmpresa(item.name) === defaultTemplateName,
      );

      if (template) {
        this.whatsAppTemplateId = template._id;
        this.onWhatsAppTemplateChange(template._id);
      }
    },
    identificarEmpresaPorPalavrasChave(empresaNormalizada) {
      if (
        empresaNormalizada.includes("CEMITERIO") &&
        empresaNormalizada.includes("MIGUEL")
      ) {
        return "CEMITERIO PREVIDA SAO MIGUEL";
      }
      if (empresaNormalizada.includes("CEMITERIO")) {
        return "CEMITERIO PREVIDA";
      }
      if (
        empresaNormalizada.includes("PARQUE") &&
        empresaNormalizada.includes("AGRESTE")
      ) {
        return "PARQUE DO AGRESTE";
      }
      if (
        empresaNormalizada.includes("PARQUE") &&
        empresaNormalizada.includes("FLORES")
      ) {
        return "PARQUE DAS FLORES";
      }
      if (
        empresaNormalizada.includes("MEMORIAL") &&
        empresaNormalizada.includes("MACEI")
      ) {
        return "MEMORIAL PARQUE MACEIO";
      }
      if (empresaNormalizada.includes("PREVIDA")) {
        return "PREVIDA";
      }
      return null;
    },
    obterConfigTelefonesEmpresa(empresa) {
      const empresaNormalizada = this.normalizarNomeEmpresa(empresa);
      const configExata = this.empresasTelefones.find((config) => {
        const nomes = [config.nome, ...(config.aliases || [])];
        return nomes.some(
          (nome) => this.normalizarNomeEmpresa(nome) === empresaNormalizada,
        );
      });

      if (configExata) return configExata;

      const nomePorPalavraChave =
        this.identificarEmpresaPorPalavrasChave(empresaNormalizada);

      return (
        this.empresasTelefones.find(
          (config) => config.nome === nomePorPalavraChave,
        ) || null
      );
    },
    obterTelefonesEmpresa(empresa) {
      const config = this.obterConfigTelefonesEmpresa(empresa);
      return config ? [...config.telefones] : [];
    },
    getCardPhone(card) {
      return this.onlyDigits(
        card?.phone ||
          card?.telefone ||
          card?.celular ||
          card?.numeroDoContato ||
          card?.whatsapp ||
          "",
      ).replace(/^55/, "");
    },
    async openWhatsAppAttendance(card) {
      if (!card) return;

      if (!this.selectedCompany) {
        this.showSnackbar(
          "Selecione uma empresa no filtro antes de iniciar o atendimento.",
          "warning",
        );
        return;
      }

      if (!this.whatsAppCompanyPhone) {
        this.showSnackbar(
          "Empresa sem telefone de WhatsApp cadastrado para envio.",
          "warning",
        );
        return;
      }

      this.resetWhatsAppDialog();
      this.whatsAppSourceCard = card;
      const phone = this.getCardPhone(card);
      this.whatsAppPhoneNumber = phone;
      this.whatsAppSearchValue = phone;
      this.whatsAppSearchType = "telefone";
      this.whatsAppDialog = true;

      await this.fetchWhatsAppTemplates();
      this.selectDefaultWhatsAppTemplate();
      if (phone && phone.length >= 8) {
        await this.searchWhatsAppClient();
      }
    },
    resetWhatsAppDialog() {
      this.whatsAppError = "";
      this.whatsAppTemplate = null;
      this.whatsAppTemplateId = null;
      this.whatsAppTemplateParams = [];
      this.whatsAppTemplateParamLabels = [];
      this.whatsAppPhoneNumber = "";
      this.whatsAppSearchType = "telefone";
      this.whatsAppSearchValue = "";
      this.whatsAppClients = [];
      this.whatsAppClientInfo = null;
      this.whatsAppClientInfoError = null;
      this.whatsAppSelectedClientIndex = 0;
      this.whatsAppSelectedClient = null;
      this.whatsAppClientError = "";
      this.whatsAppSentProtocol = null;
      if (this.$refs.whatsAppForm) {
        this.$refs.whatsAppForm.resetValidation();
      }
    },
    closeWhatsAppDialog() {
      this.whatsAppDialog = false;
      this.resetWhatsAppDialog();
      this.whatsAppSourceCard = null;
    },
    async fetchWhatsAppTemplates() {
      this.loadingWhatsAppTemplates = true;
      try {
        const response = await SonaxService.getTemplates(
          this.whatsAppCompanyPhone,
        );
        const brokers = response.data?.data?.brokers || [];
        let brokerEncontrado = brokers.find(
          (broker) => broker.number === this.whatsAppCompanyPhone,
        );

        if (
          !brokerEncontrado ||
          !brokerEncontrado.templates ||
          brokerEncontrado.templates.length === 0
        ) {
          brokerEncontrado = brokers.find(
            (broker) => broker.templates && broker.templates.length > 0,
          );
        }

        if (brokerEncontrado && brokerEncontrado.templates?.length) {
          const brokerNumber = brokerEncontrado.number;
          this.whatsAppTemplates = brokerEncontrado.templates.map(
            (template) => ({
              ...template,
              brokerNumber,
            }),
          );
        } else {
          this.whatsAppTemplates = [];
        }
      } catch (error) {
        console.error("Erro ao buscar templates:", error);
        this.whatsAppTemplates = [];
        this.whatsAppError =
          error.response?.data?.message || "Erro ao buscar templates.";
      } finally {
        this.loadingWhatsAppTemplates = false;
      }
    },
    onWhatsAppTemplateChange(templateId) {
      if (!templateId) {
        this.whatsAppTemplate = null;
        this.whatsAppTemplateParams = [];
        this.whatsAppTemplateParamLabels = [];
        return;
      }

      const template = this.activeWhatsAppTemplates.find(
        (item) => item._id === templateId,
      );
      if (!template) return;

      this.whatsAppTemplate = template;
      this.whatsAppTemplateParams = new Array(
        this.extractTemplateParams(template.content).length,
      ).fill("");
      this.whatsAppTemplateParamLabels = new Array(
        this.extractTemplateParams(template.content).length,
      ).fill("");
      this.preencherWhatsAppParamsTemplate();
    },
    extractTemplateParams(content) {
      const regex = /\{\{(\d+)\}\}/g;
      const params = [];
      let match;

      while ((match = regex.exec(content || "")) !== null) {
        params.push(match[1]);
      }

      return [...new Set(params)].sort((a, b) => a - b);
    },
    async preencherWhatsAppParamsTemplate() {
      if (
        !this.whatsAppTemplate ||
        !this.whatsAppPhoneNumber ||
        this.whatsAppPhoneNumber.length < 8
      ) {
        return;
      }

      try {
        const response = await SonaxService.preencherParametros(
          this.whatsAppTemplate.name,
          this.whatsAppPhoneNumber,
        );

        if (response.data && Array.isArray(response.data)) {
          const params = this.extractTemplateParams(
            this.whatsAppTemplate.content,
          );
          this.whatsAppTemplateParams = new Array(params.length).fill("");
          this.whatsAppTemplateParamLabels = new Array(params.length).fill("");

          response.data.forEach((item) => {
            const paramIndex = item.numeroParametro - 1;
            if (paramIndex >= 0 && paramIndex < params.length) {
              this.whatsAppTemplateParams[paramIndex] =
                item.valorPreenchido || "";
              this.whatsAppTemplateParamLabels[paramIndex] =
                item.label || `Parametro ${paramIndex + 1}`;
            }
          });
        }
      } catch (error) {
        console.error("Erro ao preencher parametros:", error);
        this.showSnackbar(
          error.response?.data?.message || "Erro ao preencher parametros.",
          "error",
        );
      }
    },
    async searchWhatsAppClient() {
      if (!this.canSearchWhatsAppClient) return;

      const valor =
        this.whatsAppSearchType === "telefone"
          ? this.onlyDigits(this.whatsAppSearchValue).replace(/^55/, "")
          : this.whatsAppSearchValue;

      this.loadingWhatsAppClients = true;
      this.whatsAppClientInfoDialog = true;
      this.whatsAppClientError = "";
      this.whatsAppClientInfoError = null;
      this.whatsAppClients = [];
      this.whatsAppClientInfo = null;
      this.whatsAppSelectedClient = null;

      try {
        const response = await SonaxService.getClienteInfo(
          valor,
          this.whatsAppSearchType,
          this.selectedCompany,
        );

        const clients = Array.isArray(response.data) ? response.data : [];
        this.whatsAppClients = clients;

        if (clients.length > 0) {
          this.whatsAppSelectedClientIndex = 0;
          this.updateWhatsAppClientInfo();
        }

        if (clients.length === 1) {
          this.selectWhatsAppClient(clients[0]);
          this.whatsAppClientInfoDialog = false;
          return;
        }

        if (clients.length > 1) {
          this.whatsAppPhoneNumber = valor;
          return;
        }

        this.whatsAppClientError =
          "Nenhuma informacao disponivel para este cliente.";
        this.whatsAppClientInfoError =
          "Nenhuma informacao disponivel para este cliente.";
        if (this.whatsAppSearchType === "telefone") {
          this.whatsAppPhoneNumber = valor;
        }
      } catch (error) {
        console.error("Erro ao buscar cliente:", error);
        this.whatsAppClientError =
          error.response?.data || "Erro ao buscar informacoes do cliente.";
        this.whatsAppClientInfoError =
          error.response?.data || "Erro ao buscar informacoes do cliente.";
        if (this.whatsAppSearchType === "telefone") {
          this.whatsAppPhoneNumber = valor;
        }
      } finally {
        this.loadingWhatsAppClients = false;
      }
    },
    updateWhatsAppClientInfo() {
      if (
        this.whatsAppClients.length > 0 &&
        this.whatsAppSelectedClientIndex >= 0 &&
        this.whatsAppSelectedClientIndex < this.whatsAppClients.length
      ) {
        this.whatsAppClientInfo =
          this.whatsAppClients[this.whatsAppSelectedClientIndex];
      } else {
        this.whatsAppClientInfo = null;
      }
    },
    selectWhatsAppClient(client) {
      this.whatsAppSelectedClient = client;
      const phone = this.onlyDigits(
        client?.telefone || this.whatsAppSearchValue,
      ).replace(/^55/, "");
      this.whatsAppPhoneNumber = phone;
      this.preencherWhatsAppParamsTemplate();
    },
    selectWhatsAppClientFromTable(item, index) {
      if (index === undefined) {
        index = this.whatsAppClients.findIndex(
          (client) =>
            client.idCliente === item.idCliente ||
            client.cpf === item.cpf ||
            client.telefone === item.telefone,
        );
      }

      if (index >= 0) {
        this.whatsAppSelectedClientIndex = index;
        this.updateWhatsAppClientInfo();

        if (item.telefone) {
          this.whatsAppPhoneNumber = this.onlyDigits(item.telefone).replace(
            /^55/,
            "",
          );
        }
      }
    },
    selectWhatsAppClientAndClose(item, index) {
      this.selectWhatsAppClientFromTable(item, index);
      this.whatsAppSelectedClient = this.whatsAppClientInfo;

      if (this.whatsAppSelectedClient?.telefone) {
        this.whatsAppPhoneNumber = this.onlyDigits(
          this.whatsAppSelectedClient.telefone,
        ).replace(/^55/, "");
      }

      this.whatsAppClientInfoDialog = false;
      this.preencherWhatsAppParamsTemplate();
    },
    clearWhatsAppSelectedClient() {
      this.whatsAppSelectedClient = null;
      this.whatsAppPhoneNumber = this.onlyDigits(
        this.whatsAppSearchValue,
      ).replace(/^55/, "");
    },
    async checkWhatsAppContactAndSend() {
      if (this.$refs.whatsAppForm && !this.$refs.whatsAppForm.validate())
        return;

      if (!this.whatsAppCompanyPhone) {
        this.showSnackbar(
          "Empresa sem telefone de WhatsApp cadastrado para envio.",
          "warning",
        );
        return;
      }

      this.checkingWhatsAppContact = true;
      try {
        const response = await SonaxService.getProtocolsByPhone(
          this.whatsAppPhoneNumber,
          this.whatsAppCompanyPhone,
        );

        const protocolosAbertos = Array.isArray(response.data)
          ? response.data.filter((protocolo) => {
              const isOpen = protocolo.status === "open";

              // Normalizar números removendo prefixo 55 para comparação
              const normalizarNumero = (num) => {
                const numStr = String(num || "").replace(/\D/g, "");
                return numStr.startsWith("55") ? numStr.substring(2) : numStr;
              };

              const numeroEmpresaProtocolo = normalizarNumero(
                protocolo.numeroEmpresa,
              );
              const numeroEmpresaAtual = normalizarNumero(
                this.whatsAppCompanyPhone,
              );
              const mesmoNumero = numeroEmpresaProtocolo === numeroEmpresaAtual;

              return isOpen && mesmoNumero;
            })
          : [];

        if (protocolosAbertos.length > 0) {
          this.whatsAppSentProtocol =
            protocolosAbertos[0].protocolNumber ||
            protocolosAbertos[0].protocol_number ||
            protocolosAbertos[0].protocolo ||
            null;
          this.whatsAppDialog = false;
          this.showSnackbar(
            "Já existe um protocolo aberto para este telefone nesta empresa.",
            "warning",
          );
          return;
        }

        await this.sendWhatsAppTemplate();
      } catch (error) {
        console.error("Erro ao verificar contato:", error);
        this.showSnackbar(
          error.response?.data?.message || "Erro ao verificar contato.",
          "error",
        );
      } finally {
        this.checkingWhatsAppContact = false;
      }
    },
    async sendWhatsAppTemplate() {
      this.sendingWhatsAppMessage = true;
      try {
        const paramsTemplate = this.whatsAppTemplateParams
          .map((param) => param.trim())
          .join(",");

        const response = await SonaxService.sendMessage({
          message: this.whatsAppTemplate.name,
          to: this.whatsAppPhoneNumber,
          from: this.whatsAppCompanyPhone,
          empresa: this.selectedCompany,
          paramsTemplate,
          primeiroContato: true,
          clienteId: this.whatsAppSelectedClient?.idCliente || null,
          clienteNome: this.whatsAppSelectedClient?.nome || null,
        });

        if (response.data && !response.data.error && response.data.protocol) {
          this.whatsAppSentProtocol =
            response.data.protocol.protocol_number ||
            response.data.protocol.protocolNumber ||
            null;
          this.whatsAppDialog = false;
          this.showSnackbar("Mensagem enviada com sucesso.", "success");
          this.openWhatsAppChatInNewTab(this.whatsAppSentProtocol);
          this.closeWhatsAppDialog();
          return true;
        } else {
          this.showSnackbar(
            response.data?.message || "Erro ao enviar mensagem.",
            "error",
          );
          return false;
        }
      } catch (error) {
        console.error("Erro ao enviar mensagem:", error);
        this.showSnackbar(
          error.response?.data?.message || "Erro ao enviar mensagem.",
          "error",
        );
        return false;
      } finally {
        this.sendingWhatsAppMessage = false;
      }
    },
    openWhatsAppChatInNewTab(protocol) {
      const query = protocol
        ? {
            protocolo: protocol,
            empresa: this.selectedCompany || undefined,
            telefoneEmpresa: this.whatsAppCompanyPhone || undefined,
          }
        : {
            empresa: this.selectedCompany || undefined,
            telefoneEmpresa: this.whatsAppCompanyPhone || undefined,
          };

      const route = this.$router.resolve({ path: "/v2chat", query });
      window.open(route.href, "_blank", "noopener");
    },
    goToChatAfterWhatsAppSend() {
      const protocol = this.whatsAppSentProtocol;
      this.openWhatsAppChatInNewTab(protocol);
      this.closeWhatsAppDialog();
    },
    async addTag(tag) {
      if (!this.selectedCard) return;

      try {
        const response = await fluxoCobrancaService.addCardTag(
          this.selectedCard.id,
          tag.id,
        );

        // Atualizar o card com os novos dados
        if (response.data) {
          const updatedCard = response.data.data || response.data;
          this.selectedCard.tags = updatedCard.tags || [];

          // Atualizar também no array de cards
          const cardIndex = this.cards.findIndex(
            (c) => c.id === this.selectedCard.id,
          );
          if (cardIndex !== -1) {
            this.cards[cardIndex].tags = updatedCard.tags || [];
          }
        }

        console.log("Tag adicionada com sucesso:", tag.nome || tag.name);
      } catch (error) {
        console.error("Erro ao adicionar tag:", error);
      }
    },
    async removeTag(tag) {
      if (!this.selectedCard) return;

      try {
        const tagId = tag.id || tag;
        const response = await fluxoCobrancaService.removeCardTag(
          this.selectedCard.id,
          tagId,
        );

        // Atualizar o card com os novos dados
        if (response.data) {
          const updatedCard = response.data.data || response.data;
          this.selectedCard.tags = updatedCard.tags || [];

          // Atualizar também no array de cards
          const cardIndex = this.cards.findIndex(
            (c) => c.id === this.selectedCard.id,
          );
          if (cardIndex !== -1) {
            this.cards[cardIndex].tags = updatedCard.tags || [];
          }
        }

        console.log("Tag removida com sucesso:", tag.nome || tag.name || tag);
      } catch (error) {
        console.error("Erro ao remover tag:", error);
      }
    },
  },
};
</script>

<style scoped>
.fluxo-cobranca-page {
  background-color: #f8f9fb;
}

.fluxo-cobranca-page >>> .v-application--wrap {
  background-color: #f8f9fb;
}

.indicadores-container {
  background-color: #eee;
  padding-bottom: 0;
}

.metric-card-wrapper {
  position: relative;
}

.metric-info-icon {
  position: absolute;
  right: 12px;
  bottom: 2px;
  cursor: pointer;
  opacity: 0.7;
  z-index: 2;
}



.recovery-goal-panel {
  background: #ffffff;
  border: 1px solid #d9e2ef;
  border-radius: 8px;
  margin: 0px 8px 30px;
  padding: 18px 16px 16px;
}

.recovery-goal-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
}

.recovery-goal-title-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  min-width: 0;
}

.recovery-goal-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}

.recovery-goal-title-row h3 {
  margin: 0;
  color: #0f172a;
  font-size: 0.92rem;
  font-weight: 800;
  line-height: 1.25;
}

.recovery-goal-title-row p {
  margin: 4px 0 0;
  color: #58708f;
  font-size: 0.78rem;
}

.recovery-goal-summary {
  text-align: right;
  color: #476282;
  font-size: 0.78rem;
  white-space: nowrap;
}

.recovery-goal-summary strong {
  display: block;
  color: #0f172a;
  font-size: 1.35rem;
  line-height: 1.1;
}

.recovery-progress-track {
  width: 100%;
  height: 12px;
  margin-top: 18px;
  background: #edf2f7;
  border-radius: 999px;
  overflow: hidden;
}

.recovery-progress-fill {
  height: 100%;
  background: #00c781;
  border-radius: inherit;
  transition: width 0.25s ease;
}

.recovery-goal-legend {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 18px;
  margin-top: 12px;
  color: #58708f;
  font-size: 0.78rem;
}

.recovery-goal-legend span {
  display: inline-flex;
  align-items: center;
  gap: 7px;
}

.recovery-goal-legend strong {
  color: #0f172a;
}

.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  flex: 0 0 auto;
}

.legend-dot.recovered {
  background: #00c781;
}

.legend-dot.remaining {
  background: #cbd5e1;
}

.legend-dot.goal {
  background: #0f172a;
}

.kanban-heading {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
}

.kanban-title {
  margin: 0;
  color: #424242;
  font-size: 1.2rem;
  font-weight: 700;
}

.kanban-subtitle {
  margin: 4px 0 0;
  color: #757575;
  font-size: 0.85rem;
}

.kanban-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.required-filter-row {
  margin-left: 0;
  margin-right: 0;
  padding: 12px 0 4px;
  background: transparent;
  border: 0;
  border-radius: 0;
}

.required-filter-row .col,
.required-filter-row [class*="col-"] {
  padding-top: 6px;
  padding-bottom: 6px;
}

.required-filter-input {
  background: transparent;
  border-radius: 4px;
}

.required-filter-input >>> .v-input__slot,
.board-filter-input >>> .v-input__slot {
  min-height: 40px !important;
}

.required-filter-input >>> .v-label,
.board-filter-input >>> .v-label {
  font-size: 0.84rem;
}

.filter-row {
  align-items: flex-end;
  gap: 0;
}

.filter-row .col,
.filter-row [class*="col-"],
.board-filters-row .col,
.board-filters-row [class*="col-"] {
  padding-top: 4px;
  padding-bottom: 4px;
}

.filter-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  padding-top: 8px;
}

.filter-actions .v-btn {
  margin-right: 0 !important;
  white-space: nowrap;
}

.board-filter-input {
  background: transparent;
  border-radius: 4px;
}

.board-filters-row {
  align-items: center;
}

.board-filter-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 0 0 auto;
  max-width: 72px;
  padding-left: 4px;
}

.required-filter-btn {
  min-height: 40px;
  border-radius: 4px;
  font-weight: 600;
}

.applied-company-chip {
  max-width: 100%;
  font-weight: 700;
}

.subtle-action-btn {
  min-height: 32px !important;
  border-radius: 4px;
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0;
}

.subtle-action-btn:hover {
  background: #f8fafc;
}

.primary-stage-btn {
  min-height: 32px !important;
  border-radius: 4px;
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0;
}

.board-view-toolbar {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
  margin-top: 18px;
}

.visualizacao-switch {
  margin-top: 0 !important;
  padding-top: 0 !important;
  display: inline-flex;
  align-items: center;
}

.fluxo-view-toolbar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 8px;
  margin-bottom: 8px;
  width: 100%;
}

.fluxo-view-toggle {
  display: inline-flex;
  padding: 0;
  background: #f8fafc;
  overflow: hidden;
}

.fluxo-view-toggle .v-btn {
  box-shadow: none !important;
  border-radius: 0 !important;
  min-width: 86px !important;
  height: 34px !important;
  text-transform: none;
  letter-spacing: 0;
  font-size: 12px;
  font-weight: 600;
  color: #475569 !important;
  background: transparent !important;
  transition: 0.18s;
}

.fluxo-view-toggle .v-btn:first-child {
  border-radius: 5px 0 0 5px !important;
}

.fluxo-view-toggle .v-btn:last-child {
  border-radius: 0 5px 5px 0 !important;
}

.fluxo-view-toggle .v-btn:hover {
  transition: scale 0.18s;
}

.fluxo-view-toggle .v-btn--active {
  background: #111827 !important;
  color: #fff !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18) !important;
}

.fluxo-view-toggle .v-btn--active .v-icon {
  color: white !important;
}

.fluxo-view-toggle .v-btn .v-icon {
  margin-right: 6px;
}

.excel-export-icon {
  color: green;
  font-size: 48px;
  line-height: 1;
  margin-right: 12px;
  cursor: pointer;
  min-width: 48px;
  min-height: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.excel-export-icon.disabled {
  color: #9ca3af;
  cursor: not-allowed;
  opacity: 0.65;
}

.ticket-list-view {
  overflow: visible;
}

.ticket-list-table {
  background: #fff;
}

.ticket-list-table >>> th {
  font-size: 11px !important;
  font-weight: bold !important;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.cor-row {
  background-color: rgb(231 244 255);
  transition: none !important;
}

.pointer {
  cursor: pointer;
}

.linha {
  font-size: 11px !important;
  font-weight: bold;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.no-hover-effect.v-data-table tbody tr:hover {
  color: #3055a4;
}

.lista-subtexto {
  color: #64748b;
  font-size: 10px;
  font-weight: 400;
  margin-top: 2px;
}

.etapa-lista-cell {
  width: 150px;
}

.cliente-lista-cell {
  width: 220px;
}

.tags-lista-cell {
  min-width: 180px;
}

.list-tag-row {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.excel-export-row {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  min-height: 58px;
  padding-top: 12px;
  padding-bottom: 2rem;
}

.kanban-board {
  padding: 16px;
  overflow-x: auto;
  padding-top: 0;
  padding-bottom: 12px;
}

.kanban-columns {
  display: flex;
  gap: 16px;
  min-height: calc(100vh - 30vh);
}

.kanban-column {
  min-width: 280px;
  max-width: 320px;
  flex: 0 0 300px;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
}

.column-header {
  min-height: 90px;
  padding: 14px;
  border-top: 0 !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 4px 4px 0 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.column-icon {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  flex: 0 0 auto;
}

.column-title {
  margin: 0;
  color: #ffffff;
  font-size: 0.98rem;
  font-weight: 700;
}

.column-description {
  margin: 1px 0 0;
  color: rgba(255, 255, 255, 0.86);
  font-size: 0.76rem;
  line-height: 1.25;
}

.column-stats {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #ffffff;
  font-size: 0.86rem;
}

.card-list {
  min-height: 180px;
  padding: 0 12px 12px;
  flex: 1;
  overflow-y: auto;
  background: #fafafa;
}

.finance-card {
  margin-bottom: 12px;
  margin-top: 8px;
  border: 1px solid #e0e0e0;
  border-left: 6px solid;
  border-radius: 8px;
  background: #ffffff;
  cursor: pointer;
  transition: 0.2s ease;
}

.finance-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.card-code {
  color: #616161;
  font-size: 0.72rem;
  font-weight: 700;
}

.card-customer {
  margin: 2px 0 0;
  color: #424242;
  font-size: 0.94rem;
  line-height: 1.25;
}

.card-customer-row {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  flex-wrap: wrap;
}

.falecido-chip {
  margin-top: 2px;
  font-weight: 700;
}

.card-description {
  margin: 10px 0;
  color: #616161;
  font-size: 0.82rem;
  line-height: 1.35;
}

.card-batch {
  display: flex;
  align-items: flex-start;
  gap: 5px;
  margin: -2px 0 10px;
  color: #546e7a;
  font-size: 0.76rem;
  line-height: 1.25;
}

.card-batch span {
  min-width: 0;
  overflow-wrap: anywhere;
}

.card-amount-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 0;
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
  color: #616161;
  font-size: 0.8rem;
}

.card-amount-row > div {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.card-amount-row small {
  margin-top: 2px;
  color: #78909c;
  font-size: 0.72rem;
  line-height: 1.15;
}

.card-amount-row strong {
  color: #424242;
  font-size: 1rem;
  white-space: nowrap;
}

.card-dates {
  display: grid;
  grid-template-columns: 1fr;
  gap: 5px;
  margin-top: 9px;
  padding: 7px 0;
  border-bottom: 1px solid #eeeeee;
  color: #607d8b;
  font-size: 0.76rem;
}

.card-dates span {
  display: flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
}

.card-dates strong {
  color: #455a64;
  font-weight: 700;
}

.card-meta {
  display: grid;
  grid-template-columns: 1fr;
  gap: 5px;
  margin-top: 7px;
  color: #757575;
  font-size: 0.78rem;
}

.card-meta span {
  display: flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
}

.contact-meta {
  padding-top: 7px;
  border-top: 1px solid #eeeeee;
  color: #455a64;
}

.contact-meta-label {
  color: #37474f;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
}

.contact-meta-value {
  color: #263238;
  font-weight: 700;
}

.contact-meta-user {
  color: #455a64;
  font-weight: 600;
}

.card-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 10px;
}

.empty-column {
  min-height: 120px;
  border: 1px dashed #d0d0d0;
  border-radius: 8px;
  color: #9e9e9e;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 0.82rem;
  margin-top: 1rem;
}

.load-more-btn {
  background-color: #f5f5f5 !important;
  border: 1px dashed #bdbdbd;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0;
}

.load-more-btn:hover {
  background-color: #eeeeee !important;
  border-color: #9e9e9e;
}

.empty-board-state {
  min-height: 160px;
  border: 1px dashed #d0d0d0;
  border-radius: 8px;
  color: #757575;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 0.9rem;
}

.customer-dialog {
  border-radius: 8px;
  position: relative;
}

.dialog-close-btn {
  position: absolute;
  top: 16px;
  right: 5px;
  z-index: 10;
  background-color: white;
}

.dialog-title {
  align-items: flex-start;
  padding-right: 56px !important;
}

.dialog-body {
  padding: 0 24px 18px !important;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
  width: 100%;
}

.dialog-customer {
  margin: 0;
  color: #424242;
  font-size: 1.2rem;
  font-weight: 800;
  line-height: 1.25;
  text-align: start;
}

.dialog-contract {
  margin-top: 4px;
  color: #757575;
  font-size: 0.86rem;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.dialog-amount {
  min-width: 148px;
  text-align: right;
}

.dialog-amount span {
  display: block;
  color: #757575;
  font-size: 0.76rem;
}

.dialog-amount strong {
  display: block;
  color: #424242;
  font-size: 1.35rem;
  line-height: 1.2;
}

.dialog-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 16px;
}

.quick-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 16px;
  padding: 12px 0;
  border-top: 1px solid #e0e0e0;
}

.quick-actions-label {
  color: #616161;
  font-size: 0.8rem;
  font-weight: 600;
  margin-right: 4px;
}

.quick-action-btn {
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0;
}

.custom-tabs {
  background-color: #fafafa;
  margin-top: 0px;
}

.custom-tabs .v-tab {
  color: #616161;
  font-size: 0.84rem;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
}

.custom-tabs .v-tab--active {
  color: #3055a4;
}

.detail-tabs-content {
  background: transparent;
}

.detail-section {
  padding-top: 16px;
}

.section-kicker {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #616161;
  font-size: 0.78rem;
  font-weight: 800;
  text-transform: uppercase;
}

.section-title {
  margin: 8px 0 4px;
  color: #424242;
  font-size: 0.98rem;
  font-weight: 800;
}

.section-subtitle {
  margin: 0 0 14px;
  color: #757575;
  font-size: 0.82rem;
}

.data-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 26px;
}

.data-item {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  color: #424242;
  font-size: 0.86rem;
}

.data-item span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.record-row,
.interaction-row,
.protocol-row,
.installment-row {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #ffffff;
}

.record-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  margin-top: 8px;
}

.record-row strong,
.record-row span {
  display: block;
}

.record-row strong {
  color: #424242;
  font-size: 0.86rem;
}

.record-row span {
  color: #757575;
  font-size: 0.78rem;
}

.installment-filter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
  color: #757575;
  font-size: 0.8rem;
}

.installment-row {
  display: grid;
  grid-template-columns: auto minmax(130px, 0.8fr) minmax(150px, 1fr) minmax(
      210px,
      1.3fr
    );
  align-items: center;
  gap: 16px;
  padding: 8px 14px;
  margin-bottom: 8px;
}

.installment-status {
  min-width: 72px;
  justify-content: center;
  font-weight: 600;
  text-transform: uppercase;
}

.installment-main,
.installment-values,
.installment-dates {
  display: grid;
  gap: 4px;
  min-width: 0;
}

.installment-main strong,
.installment-values strong {
  color: #424242;
  font-size: 0.88rem;
}

.installment-main span,
.installment-values span,
.installment-dates {
  color: #757575;
  font-size: 0.76rem;
}

.installment-values {
  grid-template-columns: auto auto;
  column-gap: 10px;
}

.installment-values strong {
  text-align: right;
}

.installment-values .received-value {
  color: #00897b;
}

.installment-dates span {
  display: flex;
  align-items: center;
  gap: 5px;
}

.interaction-row {
  padding: 12px;
  margin-bottom: 8px;
}

.protocol-filter-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
  color: #757575;
  font-size: 0.8rem;
}

.protocol-row {
  padding: 12px;
  margin-bottom: 8px;
}

.protocol-row-main,
.protocol-row-footer,
.protocol-message-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.protocol-row-main strong,
.protocol-row-main span {
  display: block;
}

.protocol-row-main strong {
  color: #424242;
  font-size: 0.86rem;
}

.protocol-row-main span,
.protocol-row-footer {
  color: #757575;
  font-size: 0.78rem;
}

.protocol-row-footer {
  margin-top: 10px;
}

.protocol-messages-card {
  padding: 18px 24px !important;
}

.protocol-loading {
  min-height: 96px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #616161;
}

.reneg-context {
  display: grid;
  gap: 4px;
  margin-bottom: 14px;
  color: #424242;
}

.reneg-context span {
  color: #757575;
  font-size: 0.82rem;
}

.responsible-context {
  display: grid;
  gap: 8px;
  padding: 12px 14px;
  margin-bottom: 16px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #f8fafc;
  color: #263238;
}

.responsible-context strong {
  display: block;
  line-height: 1.25;
}

.responsible-context span {
  display: grid;
  gap: 2px;
  color: #546e7a;
  font-size: 0.86rem;
}

.responsible-context small {
  color: #90a4ae;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: uppercase;
}

.responsible-option {
  display: grid;
  gap: 2px;
  min-width: 0;
  padding: 4px 0;
}

.responsible-option strong,
.responsible-selection {
  color: #263238;
  font-size: 0.9rem;
  font-weight: 600;
  line-height: 1.25;
}

.responsible-option span {
  color: #78909c;
  font-size: 0.78rem;
  line-height: 1.2;
}

.reneg-list {
  margin-top: 0;
}

.reneg-option {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 12px;
  margin-bottom: 8px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  background: #ffffff;
}

.reneg-option-body {
  flex: 1;
  min-width: 0;
}

.reneg-option-title {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  color: #424242;
  font-size: 0.88rem;
}

.reneg-option-title span {
  color: #757575;
  font-size: 0.78rem;
}

.reneg-option-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 5px 12px;
  margin-top: 7px;
  color: #616161;
  font-size: 0.78rem;
}

.protocol-message-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.protocol-message-bubble {
  max-width: 82%;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  background: #ffffff;
}

.protocol-message-bubble p {
  margin: 8px 0 0;
  color: #424242;
  font-size: 0.9rem;
  white-space: pre-wrap;
}

.incoming-message {
  align-self: flex-start;
}

.outgoing-message {
  align-self: flex-end;
  background: #e8f5e9;
  border-color: #c8e6c9;
}

.protocol-message-meta,
.protocol-message-user {
  color: #757575;
  font-size: 0.74rem;
}

.protocol-message-file {
  margin-top: 8px;
}

.stage-history-row {
  display: grid;
  grid-template-columns: minmax(160px, 1fr) minmax(220px, 1.4fr);
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  margin-bottom: 8px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #ffffff;
}

.stage-history-row strong,
.stage-history-row span {
  display: block;
}

.stage-history-row strong {
  color: #424242;
  font-size: 0.86rem;
}

.stage-history-row span,
.stage-history-dates {
  color: #757575;
  font-size: 0.78rem;
}

.stage-history-dates {
  display: grid;
  gap: 4px;
}

.interaction-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 7px;
  color: #757575;
  font-size: 0.78rem;
}

.interaction-message {
  margin: 8px 0 0 28px;
}

.interaction-message p {
  margin: 0;
  color: #424242;
  font-size: 0.9rem;
  white-space: pre-line;
}

.interaction-message-clamped {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
}

.interaction-expand-btn {
  min-width: 0 !important;
  height: 22px !important;
  margin-top: 2px;
  padding: 0 2px !important;
  font-size: 0.7rem !important;
  letter-spacing: 0;
  text-transform: none;
}

.empty-detail {
  min-height: 80px;
  border: 1px dashed #d0d0d0;
  border-radius: 8px;
  color: #9e9e9e;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.86rem;
}

.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.expansion-panel {
  border-radius: 8px;
  border: 1px solid rgb(224 224 224);
}

.stage-actions {
  color: #757575;
  font-size: 0.8rem;
  width: 100%;
}

.stage-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}

.stage-buttons .v-btn {
  text-transform: none;
}

.detail-grid {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 8px 16px;
  color: #757575;
}

.detail-grid strong {
  color: #424242;
}

.min-width-0 {
  min-width: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(8px);
}

@media (max-width: 760px) {
  .recovery-goal-header {
    flex-direction: column;
  }

  .recovery-goal-summary {
    text-align: left;
    white-space: normal;
  }

  .kanban-heading {
    flex-direction: column;
  }

  .kanban-actions {
    width: 100%;
    justify-content: flex-start;
  }

  .kanban-column {
    min-width: 286px;
    flex-basis: 286px;
  }

  .dialog-body {
    padding: 22px 16px 18px !important;
  }

  .dialog-header,
  .installment-filter {
    flex-direction: column;
    align-items: flex-start;
  }

  .dialog-amount {
    text-align: left;
  }

  .data-grid,
  .installment-row,
  .stage-history-row,
  .reneg-option-grid {
    grid-template-columns: 1fr;
  }
}

.custom-gray-background {
  background-color: #f5f5f5;
  padding: 16px;
  border-radius: 8px;
}

.custom-gray-background span {
  display: block;
  margin-bottom: 8px;
  font-size: 0.875rem;
  color: #616161;
  font-weight: 500;
}
</style>
